import React, { useState, useEffect, useRef, useMemo } from "react";
import { useLocation } from "react-router-dom";
import axios from "../../../axios-order"; // Ensure this is correctly configured
import BoxWrapper from "../../../components/ui/boxWrapper";

import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import AssessmentIcon from '@mui/icons-material/Assessment';
import DescriptionIcon from '@mui/icons-material/Description';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import SendIcon from '@mui/icons-material/Send';
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { canWrite } from "../../../utils/privilegeUtils";

import {
    Box,
    Typography,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    CircularProgress,
    Grid,
    Paper,
    Checkbox,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Chip,
    Collapse,
    InputAdornment,
    Stack,
    Alert,
    Snackbar,
    Divider
} from '@mui/material';

import {
    makeStyles,
} from "@material-ui/core";
import {
    DataGridPro,
    useGridApiRef,
    gridFilteredSortedRowEntriesSelector,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarDensitySelector,
} from "@mui/x-data-grid-pro";
import ToggleSwitch from "../../../components/ui/ToggleSwitch/ToggleSwitch"; // Ensure this path is correct
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import RefreshIcon from "@mui/icons-material/Refresh";
import TurnedInNotIcon from "@mui/icons-material/TurnedInNot";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import DataTables from "material-ui-datatables"; // Consider replacing with @mui/x-data-grid-pro
import './StatusCards.css'; // Import the CSS for styled cards (from previous response)
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import greenthumbs from '../../../asserts/images/greenthumb.png';
import orangethumbs from '../../../asserts/images/orange.png';
import redthumbs from '../../../asserts/images/redthumb.png';
import chartofaccounts from '../../../asserts/templates/chart_of_accounts_template.xlsx'
import ZohoModel from "../../../components/ZohoModel/ZohoModel";
import moment from "moment";

// CSS for upload section and cards
const uploadStyles = `
  @keyframes rotate {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @keyframes checkmark {
    0% { stroke-dashoffset: 100; }
    100% { stroke-dashoffset: 0; }
  }

  @keyframes successPulse {
    0% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.1); opacity: 0.8; }
    100% { transform: scale(1); opacity: 1; }
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }

  .upload-container {
    width: 40%;
    border: 2px dashed #87b5ceff;
    border-radius: 16px;
    padding: 24px;
    text-align: center;
    background: linear-gradient(145deg, #fafafa 0%, #f5f5f5 100%);
    position: relative;
    margin-bottom: 24px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    min-height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .upload-container.drag-active {
    border-color: #2196f3;
    background: linear-gradient(145deg, #e3f2fd 0%, #bbdefb 100%);
    transform: scale(1.02);
  }

  .upload-container.uploading {
    border-color: #2196f3;
    background: linear-gradient(145deg, #e8f5e8 0%, #c8e6c9 100%);
  }

  .upload-container.success {
    border-color: #4caf50;
    background: linear-gradient(145deg, #e8f5e8 0%, #c8e6c9 100%);
    animation: successPulse 0.6s ease-in-out;
  }

  .upload-icon-container {
    position: relative;
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .progress-circle {
    width: 80px;
    height: 80px;
    transform: rotate(-90deg);
  }

  .progress-circle-bg {
    fill: none;
    stroke: #e0e0e0;
    stroke-width: 3;
  }

  .progress-circle-fill {
    fill: none;
    stroke: #2196f3;
    stroke-width: 3;
    stroke-linecap: round;
    transition: stroke-dashoffset 0.3s ease;
  }

  .upload-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #bdbdbd;
    transition: all 0.3s ease;
  }

  .success-circle {
    width: 80px;
    height: 80px;
    background: #4caf50;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: successPulse 0.6s ease-in-out;
  }

  .checkmark {
    stroke: white;
    stroke-width: 3;
    stroke-linecap: round;
    stroke-linejoin: round;
    fill: none;
    stroke-dasharray: 100;
    animation: checkmark 0.6s ease-in-out 0.3s both;
  }

  .upload-text {
    font-size: 18px;
    color: #666;
    margin-bottom: 24px;
    font-weight: 400;
    animation: fadeIn 0.5s ease-in-out;
  }

  .upload-text.success {
    color: #4caf50;
    font-weight: 500;
  }

  .choose-file-btn {
    background: linear-gradient(45deg, #2196f3 0%, #21cbf3 100%);
    color: white;
    border: none;
    border-radius: 50px;
    padding: 14px 32px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(33, 150, 243, 0.3);
    text-transform: none;
  }

  .choose-file-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(33, 150, 243, 0.4);
  }

  .choose-file-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  .file-input {
    display: none;
  }

  .file-name {
    margin-top: 16px;
    color: #333;
    font-size: 14px;
    font-weight: 500;
    animation: fadeIn 0.5s ease-in-out;
  }

  .upload-btn {
    background: linear-gradient(45deg, #4caf50 0%, #8bc34a 100%);
    color: white;
    border: none;
    border-radius: 12px;
    padding: 12px 24px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    margin-top: 16px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
    text-transform: none;
  }

  .upload-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4);
  }

  .upload-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        width: "100%",
        position: "relative",
    },
    uploadSection: {
        background: "transparent",
        borderRadius: "15px",
        padding: theme.spacing(4),
        boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)",
        maxWidth: "500px",
        width: "100%",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(3),
        border: "2px dashed #007bff",
        borderColor: "#007bff",
        margin: "auto",
    },
    fileInput: {
        display: "none",
    },
    fileName: {
        color: "#444",
        fontSize: "0.95rem",
        fontWeight: "bold",
        wordBreak: "break-word",
        textAlign: "center",
    },
    uploadButton: {
        background: "linear-gradient(90deg, #4a90e2, #007aff)",
        color: "#ffffff",
        fontWeight: 700,
        padding: theme.spacing(1.5, 4),
        borderRadius: "30px",
        textTransform: "uppercase",
        fontSize: "1.1rem",
        transition: "all 0.3s ease",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            background: "linear-gradient(90deg, #2ecc71, #1abc9c)",
            transform: "scale(1.05)",
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
        },
    },
    icon: {
        marginRight: theme.spacing(1),
    },
    leftIconButtonsContainer: {
        position: "absolute",
        left: "16px",
        display: "flex",
        gap: theme.spacing(2),
    },
    rightIconButtonsContainer: {
        position: "absolute",
        right: "16px",
        display: "flex",
        gap: theme.spacing(2),
    },
}));

const sellerCustomerCol = [
    // {
    //     label: "GSTIN",
    //     render: (name, all) => all["record"]["GSTIN"],
    // },
    // {
    //     label: "Invoice Number",
    //     render: (name, all) => all["record"]["InvoiceNo"],
    // },
    { key: "row", label: "Row #" },
    {
        label: "Errors",
        render: (name, all) => {
            return Object.keys(all["errors_in"]).map((i, v) => (
                <div style={{ whiteSpace: "pre-wrap" }} key={v}>
                    <span>{i}</span> <span>:</span>{" "}
                    <span style={{ color: "red" }}>{all["errors_in"][i].join(",")}</span>
                </div>
            ));
        },
    },
];

const pAndLTypeOptions = [
    "Income",
    "Expense",
    "Expense-Purchases",
    "Expense-Freight / Carriage",
    "Expense-Power and Fuel Costs",
    "Expense-Imported goods (Including received from SEZ)",
    "Expense-Rent and Insurance Expense",
    "Expense-Goods lost, stolen, destroyed, written off or disposed of by way of gift or free samples",
    "Expense-Royalties",
    "Expense-Employee's Cost (Salaries, Wages, Bonus etc.)",
    "Expense-Conveyance charges",
    "Expense-Bank Charges",
    "Expense-Entertainment charges",
    "Expense-Stationery Expenses (including postage etc.)",
    "Expense-Repair and Maintenance",
    "Expense-Other Miscellaneous expenses",
    "Expense-Capital goods",
];

const Header = [
    { label: "FS Type" },
    { label: "Ledger Group 1" },
    { label: "Ledger Group 2" },
    { label: "Ledger Group 3" },
    { label: "Ledger Group 4" },
    { label: "Ledger ID" },
    { label: "Ledger Code" },
    { label: "Ledger Name" },
];

const Column = [
    {
        key: "fs_type",
        render: (index, row) => {
            return row["fs_type"];
        },
    },
    {
        key: "ledger_group_1",
        render: (index, row) => {
            return row["ledger_group_1"];
        },
    },
    {
        key: "ledger_group_2",
        render: (index, row) => {
            return row["ledger_group_2"];
        },
    },
    {
        key: "ledger_group_3",
        render: (index, row) => {
            return row["ledger_group_3"];
        },
    },
    {
        key: "ledger_group_4",
        render: (index, row) => {
            return row["ledger_group_4"];
        },
    },
    {
        key: "ledger_id",
        render: (index, row) => {
            return row["ledger_id"];
        },
    },
    {
        key: "ledger_code",
        render: (index, row) => {
            return row["ledger_code"];
        },
    },
    {
        key: "ledger_name",
        render: (index, row) => {
            return row["ledger_name"];
        },
    },
];

const actionHeaderForZoho = [
    { id: "erpVendorCode", name: "ERP Vendor Code+" },
    { id: "vendorPan", name: "PAN" },
    { id: "bookingDate", name: "Booking date" },
    { id: "eInvoice", name: "E-Invoice" },
    { id: "hsnSacCode", name: "HSN/SAC Code" },
    { id: "taxableValue", name: "Taxable Value" },
    { id: "nonTaxableValue", name: "Non Taxable Value" },
    { id: "sgst", name: "SGST" },
    { id: "cgst", name: "CGST" },
    { id: "igst", name: "IGST" },
    { id: "cess", name: "CESS" },
    { id: "taxAmount", name: "Tax Amount" },
    { id: "tcsSection", name: "TCS Section" },
    { id: "tcsPayable", name: "TCS Payable" },
    { id: "totalAmount", name: "Total Amount" },
    { id: "tdsSection", name: "TDS Section" },
    { id: "tdsPayable", name: "TDS Payables" },
    { id: "expenseType", name: "Expense Type" },
    { id: "taxCreditType", name: "Type of tax credit" },
    { id: "itcEligibility", name: "ITC Eligibility" },
    { id: "rcmApplicability", name: "RCM Applicability" },
    { id: "dispute", name: "Dispute" },
    { id: "disputeValue", name: "Dispute Value" },
    { id: "debitNoteReason", name: "Debit Note Reason" },
    { id: "boeNumber", name: "Bill of Entry Number" },
    { id: "boeDate", name: "Bill of Entry Date" },
    { id: "referenceDate", name: "Reference Date" },
    { id: "portCode", name: "Port Code" },
    { id: "fetrack", name: "Fetrack" },
];

const gstApplicableOptions = ["Yes", "No"];
const tdsApplicableOptions = ["Yes", "No"];
const tcsApplicableOptions = ["Yes", "No"];
const gstTypeSupplyOptions = ["Services", "Goods"];
const gstNatureofSupplyOptions = ["Taxable", "Nil", "Exempt", "Non-GST Supply"];

const columns = (handleStatusChange, recordStatuses) => [
    {
        field: "fs_type",
        headerName: "Type",
        flex: 1,
        minWidth: 150,
        align: "center",
        headerAlign: "center",
        filterable: true,
    },
    {
        field: "ledger_group_1",
        headerName: "LEDGER GROUP1",
        flex: 1,
        minWidth: 150,
        align: "center",
        headerAlign: "center",
        filterable: true,
    },
    {
        field: "ledger_group_2",
        headerName: "LEDGER GROUP2",
        flex: 1,
        minWidth: 200,
        align: "center",
        headerAlign: "center",
        filterable: true,
    },
    {
        field: "ledger_group_3",
        headerName: "LEDGER GROUP3",
        flex: 0.7,
        minWidth: 120,
        align: "center",
        headerAlign: "center",
        filterable: true,
    },
    {
        field: "ledger_group_4",
        headerName: "LEDGER GROUP4",
        flex: 1,
        minWidth: 180,
        align: "center",
        headerAlign: "center",
        filterable: true,
    },
    {
        field: "ledger_id",
        headerName: "LEDGER ID",
        flex: 1,
        minWidth: 180,
        align: "center",
        headerAlign: "center",
        filterable: true,
    },
    {
        field: "ledger_code",
        headerName: "LEDGER CODE",
        flex: 1,
        minWidth: 180,
        align: "center",
        headerAlign: "center",
        filterable: true,
    },
    {
        field: "p_and_l_type",
        headerName: "P&L Type",
        flex: 1,
        minWidth: 120,
        align: "center",
        headerAlign: "center",
        filterable: false,
        sortable: false,
        renderCell: (params) => {
            if (params.row.fs_type === "BS") {
                return <Typography></Typography>; // Empty or placeholder for BS
            }
            return (
                <FormControl size="small" sx={{ minWidth: 100 }}>
                    <Select
                        value={recordStatuses[params.row.id]?.p_and_l_type || params.row.p_and_l_type || ""}
                        onChange={(e) => handleStatusChange(params.row.id, "p_and_l_type", e.target.value)}
                        sx={{ fontSize: "0.875rem" }}
                    >
                        <MenuItem value="" disabled>Select</MenuItem>
                        {pAndLTypeOptions.map((option) => (
                            <MenuItem key={option} value={option}>
                                {option}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            );
        },
    },
    {
        field: "ledger_name",
        headerName: "LEDGER NAME",
        flex: 1,
        minWidth: 150,
        align: "center",
        headerAlign: "center",
        filterable: true,
    },
    {
        field: "gst_applicable",
        headerName: "GST APPLICABLE",
        flex: 1,
        minWidth: 120,
        align: "center",
        headerAlign: "center",
        filterable: true,
        sortable: false,
        renderCell: (params) => (
            <FormControl size="small" sx={{ minWidth: 100 }}>
                <Select
                    value={recordStatuses[params.row.id]?.gst_applicable || params.row.gst_applicable || ""}
                    onChange={(e) => handleStatusChange(params.row.id, "gst_applicable", e.target.value)}
                    sx={{ fontSize: "0.875rem" }}
                >
                    <MenuItem value="" disabled>Select</MenuItem>
                    {gstApplicableOptions.map((option) => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        ),
    },
    {
        field: "tds_applicable",
        headerName: "TDS APPLICABLE",
        flex: 1,
        minWidth: 200,
        align: "center",
        headerAlign: "center",
        filterable: true,
        sortable: false,
        renderCell: (params) => (
            <FormControl size="small" sx={{ minWidth: 100 }}>
                <Select
                    value={recordStatuses[params.row.id]?.tds_applicable || params.row.tds_applicable || ""}
                    onChange={(e) => handleStatusChange(params.row.id, "tds_applicable", e.target.value)}
                    sx={{ fontSize: "0.875rem" }}
                >
                    <MenuItem value="" disabled>Select</MenuItem>
                    {tdsApplicableOptions.map((option) => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        ),
    },
    {
        field: "tcs_applicable",
        headerName: "TCS APPLICABLE",
        flex: 0.7,
        minWidth: 120,
        align: "center",
        headerAlign: "center",
        filterable: true,
        sortable: false,
        renderCell: (params) => (
            <FormControl size="small" sx={{ minWidth: 100 }}>
                <Select
                    value={recordStatuses[params.row.id]?.tcs_applicable || params.row.tcs_applicable || ""}
                    onChange={(e) => handleStatusChange(params.row.id, "tcs_applicable", e.target.value)}
                    sx={{ fontSize: "0.875rem" }}
                >
                    <MenuItem value="" disabled>Select</MenuItem>
                    {tcsApplicableOptions.map((option) => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        ),
    },
    {
        field: "gst_type_of_supply",
        headerName: "GST TYPE OF SUPPLY",
        flex: 1,
        minWidth: 180,
        align: "center",
        headerAlign: "center",
        filterable: true,
        sortable: false,
        renderCell: (params) => (
            <FormControl size="small" sx={{ minWidth: 100 }}>
                <Select
                    value={recordStatuses[params.row.id]?.gst_type_of_supply || params.row.gst_type_of_supply || ""}
                    onChange={(e) => handleStatusChange(params.row.id, "gst_type_of_supply", e.target.value)}
                    sx={{ fontSize: "0.875rem" }}
                >
                    <MenuItem value="" disabled>
                        Select
                    </MenuItem>
                    {gstTypeSupplyOptions.map((option) => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        ),
    },
    {
        field: "gst_nature_of_supply",
        headerName: "GST NATURE OF SUPPLY",
        flex: 1,
        minWidth: 180,
        align: "center",
        headerAlign: "center",
        filterable: true,
        sortable: false,
        renderCell: (params) => (
            <FormControl size="small" sx={{ minWidth: 100 }}>
                <Select
                    value={recordStatuses[params.row.id]?.gst_nature_of_supply || params.row.gst_nature_of_supply || ""}
                    onChange={(e) => handleStatusChange(params.row.id, "gst_nature_of_supply", e.target.value)}
                    sx={{ fontSize: "0.875rem" }}
                >
                    <MenuItem value="" disabled>
                        Select
                    </MenuItem>
                    {gstNatureofSupplyOptions.map((option) => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        ),
    },
    {
        field: "tds_section_number",
        headerName: "TDS SECTION NUMBER",
        flex: 1,
        minWidth: 180,
        align: "center",
        headerAlign: "center",
        filterable: true,
    },
    {
        field: "tcs_section_number",
        headerName: "TCS SECTION NUMBER",
        flex: 1,
        minWidth: 180,
        align: "center",
        headerAlign: "center",
        filterable: true,
    },
    {
        field: "hsn_code",
        headerName: "HSN CODE",
        flex: 0.7,
        minWidth: 120,
        align: "center",
        headerAlign: "center",
        filterable: true,
    },
    {
        field: "igst_rate",
        headerName: "IGST RATE",
        flex: 1,
        minWidth: 180,
        align: "center",
        headerAlign: "center",
        filterable: true,
    },
    {
        field: "cgst_rate",
        headerName: "CGST RATE",
        flex: 1,
        minWidth: 180,
        align: "center",
        headerAlign: "center",
        filterable: true,
    },
    {
        field: "sgst_rate",
        headerName: "SGST RATE",
        flex: 1,
        minWidth: 180,
        align: "center",
        headerAlign: "center",
        filterable: true,
    },
    {
        field: "cess_rate",
        headerName: "CESS RATE",
        flex: 1,
        minWidth: 180,
        align: "center",
        headerAlign: "center",
        filterable: true,
    },
    {
        field: "opening_balance",
        headerName: "OPENING BALANCE",
        flex: 1,
        minWidth: 180,
        align: "center",
        headerAlign: "center",
        filterable: true,
    },
];

const CustomToolbar = ({
    onSubmit,
    zohoEffitracEnable,
    enableImportToEffTallybutton,
    handleZohoDrawer,
    importEffitracTally,
    erpConnectorName,
    onZoho
}) => (
    <Box
        sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            height: "60px",
            flexWrap: "wrap",
            gap: 1,
            padding: "3px 10px",
            backgroundColor: "#ffffff",
            borderRadius: "4px",
            boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        }}
    >
        <Box sx={{ display: "flex", gap: 1 }}>
            <GridToolbarColumnsButton
                sx={{
                    borderColor: "#1976d2",
                    color: "#1976d2",
                    borderRadius: "4px",
                    padding: "2px 4px",
                    "&:hover": { borderColor: "#1565c0", backgroundColor: "#e3f2fd" },
                }}
            />
            <GridToolbarFilterButton
                sx={{
                    borderColor: "#1976d2",
                    color: "#1976d2",
                    borderRadius: "4px",
                    padding: "2px 4px",
                    "&:hover": { borderColor: "#1565c0", backgroundColor: "#e3f2fd" },
                }}
                PopperProps={{
                    style: { zIndex: 1300 },
                }}
            />
            <GridToolbarDensitySelector
                sx={{
                    borderColor: "#1976d2",
                    color: "#1976d2",
                    borderRadius: "4px",
                    padding: "2px 4px",
                    "&:hover": { borderColor: "#1565c0", backgroundColor: "#e3f2fd" },
                }}
            />
            {zohoEffitracEnable && (
                <Button
                    variant="outlined"
                    onClick={handleZohoDrawer}
                    sx={{
                        borderColor: "#1976d2",
                        color: "#1976d2",
                        borderRadius: "4px",
                        padding: "2px 4px",
                        "&:hover": { borderColor: "#1565c0", backgroundColor: "#e3f2fd" },
                    }}
                >
                    Zoho Effitrac
                </Button>
            )}
            {enableImportToEffTallybutton && (
                <Button
                    variant="outlined"
                    onClick={importEffitracTally}
                    sx={{
                        borderColor: "#1976d2",
                        color: "#1976d2",
                        borderRadius: "4px",
                        padding: "2px 4px",
                        "&:hover": { borderColor: "#1565c0", backgroundColor: "#e3f2fd" },
                    }}
                >
                    Import to EffiTally
                </Button>
            )}
            {/* {erpConnectorName && (
                <Button
                    variant="outlined"
                    onClick={handleZohoDrawer}
                    sx={{
                        borderColor: "#1976d2",
                        color: "#1976d2",
                        borderRadius: "4px",
                        padding: "2px 4px",
                        "&:hover": { borderColor: "#1565c0", backgroundColor: "#e3f2fd" },
                    }}
                >
                    {erpConnectorName}
                </Button>
            )} */}
        </Box>
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            {erpConnectorName && localStorage.getItem("Client_ID") && (
                <button
                    className="button-outlined-primary"
                    style={{
                        width: `${erpConnectorName.length * 8 + 20}px`,
                        height: "59%",
                        marginTop: "1%"
                    }}
                    onClick={onZoho}
                >
                    {erpConnectorName}
                </button>
            )}
            <button
                className="button-outlined-primary"
                style={{
                    width: `${"Submit".length * 8 + 20}px`,
                    height: "59%",
                    marginTop: "1%"
                }}
                onClick={onSubmit}
            >
                Submit
            </button>
        </Box>
    </Box>
);

const CustomNoRowsOverlay = () => (
    <Box
        sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            fontSize: "16px",
            fontWeight: "medium",
            color: "text.secondary",
        }}
    >
        No Data Available
    </Box>
);

const LogTable = ({ recordForLogTable, loaderForTable, getManualLog, setSnackbar, onClickRefresh, uploadState, uploadProgress, selectedFile, handleFileChange, handleFileUploadWithAnimation, erpConnectorName, onErpConnectorClick }) => {
    const [showGrid, setShowGrid] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [successfulRecords, setSuccessfulRecords] = useState(0);
    const [errorRecords, setErrorRecords] = useState(0);
    const [sellerCustomerData, setSellerCustomerData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    // Pagination state
    const [currentErrorPage, setCurrentErrorPage] = useState(1);
    const [errorRowsPerPage, setErrorRowsPerPage] = useState(10);
    const [errorTotal, setErrorTotal] = useState(0);
    const [currentFilter, setCurrentFilter] = useState('error');

    const handleActionClick = async (row, pageParam = 1, perPage = 10) => {
        let currentId = row?.id || localStorage.getItem('uploadReportId');

        if (!currentId) {
            setShowGrid(true);
            setTotalRecords(0);
            setSuccessfulRecords(0);
            setErrorRecords(0);
            setSellerCustomerData([]);
            setFilteredData([]);
            setError("Invalid ID");
            setSnackbar({
                open: true,
                message: "Invalid ID",
                severity: "error",
            });
            return;
        }

        localStorage.setItem('uploadReportId', currentId);

        try {
            const response = await axios.get(`/arc/get_data_upload_json/${currentId}/${pageParam}/${perPage}`);
            const res = response.data.records;

            if (res?.type === "json" && res.records?.details && res.records?.summary) {
                const allRecords = res.records.details || [];
                const errorRecordsData = allRecords.filter((v) => v.status === "Fail");
                const successRecordsData = allRecords.filter((v) => v.status === "Pass");

                setShowGrid(true);
                setTotalRecords(parseInt(res.records.summary?.total_records || 0));
                setSuccessfulRecords(parseInt(res.records.summary?.valid_records || 0));
                setErrorRecords(parseInt(res.records.summary?.invalid_records || 0));
                setSellerCustomerData(allRecords);

                const totalFromResponse = response.data.total || res.records.summary?.total_records || 0;
                setErrorTotal(parseInt(totalFromResponse));

                if (currentFilter === 'error') {
                    setFilteredData(errorRecordsData);
                } else {
                    setFilteredData(successRecordsData);
                }

                setError(null);
            } else {
                setShowGrid(true);
                setTotalRecords(0);
                setSuccessfulRecords(0);
                setErrorRecords(0);
                setSellerCustomerData([]);
                setFilteredData([]);
                setError(res?.message || "Invalid response format");
                setSnackbar({
                    open: true,
                    message: res?.message || "Invalid response format",
                    severity: "error",
                });
            }
        } catch (error) {
            console.error("Error fetching upload report:", {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
            });
            setShowGrid(true);
            setTotalRecords(0);
            setSuccessfulRecords(0);
            setErrorRecords(0);
            setSellerCustomerData([]);
            setFilteredData([]);
            setError(error.response?.data?.message || "Failed to fetch upload report");
            setSnackbar({
                open: true,
                message: error.response?.data?.message || "Failed to fetch upload report",
                severity: "error",
            });
        }
    };

    const handleNextPage = () => {
        const totalPages = Math.ceil(errorTotal / errorRowsPerPage);

        if (currentErrorPage < totalPages) {
            const newPage = currentErrorPage + 1;
            console.log(`Navigating to page ${newPage}`);
            setCurrentErrorPage(newPage);

            const currentId = localStorage.getItem('uploadReportId');
            if (currentId) {
                handleActionClick({ id: currentId }, newPage, errorRowsPerPage);
            }
        }
    };

    const handlePreviousPage = () => {
        if (currentErrorPage > 1) {
            const newPage = currentErrorPage - 1;
            console.log(`Navigating to page ${newPage}`);
            setCurrentErrorPage(newPage);

            const currentId = localStorage.getItem('uploadReportId');
            if (currentId) {
                handleActionClick({ id: currentId }, newPage, errorRowsPerPage);
            }
        }
    };

    const handleRowsPerPageChange = (index, value) => {
        console.log(`Changing rows per page to ${value}`);
        setErrorRowsPerPage(value);
        setCurrentErrorPage(1);

        const currentId = localStorage.getItem('uploadReportId');
        if (currentId) {
            handleActionClick({ id: currentId }, 1, value);
        }
    };

    const handleViewDetails = () => {
        setCurrentFilter('success');
        const successRecords = sellerCustomerData.filter((v) => v.status === "Pass");
        setFilteredData(successRecords);
        setErrorTotal(successfulRecords);
        setCurrentErrorPage(1);
    };

    const handleViewErrors = () => {
        setCurrentFilter('error');
        const errorRecordsData = sellerCustomerData.filter((v) => v.status === "Fail");
        setFilteredData(errorRecordsData);
        setErrorTotal(errorRecords);
        setCurrentErrorPage(1);
    };

    return (
        <>
            <BoxWrapper
                boxTitle="Upload History"
                enableSecondButton={erpConnectorName && localStorage.getItem("Client_ID") && canWrite("CHART OF ACCOUNTS") ? true : false}
                secondButtonLabel={erpConnectorName}
                secondButtonHandlerFn={onErpConnectorClick}
            >
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2
                }}>
                    {/* Upload Widget */}
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2
                    }}>
                        {/* Upload Button */}
                         {canWrite("CHART OF ACCOUNTS") && (
                        <Button
                            variant="contained"
                            startIcon={uploadState === "success" ? <CheckCircleOutlineIcon /> : <CloudUploadIcon />}
                            onClick={() => {
                                if (uploadState !== "uploading" && uploadState !== "success") {
                                    document.getElementById("excel-upload-input").click();
                                }
                            }}
                            disabled={uploadState === "uploading"}
                            sx={{
                                textTransform: 'none',
                                backgroundColor: uploadState === "success" ? '#10b981' :
                                    uploadState === "uploading" ? '#94a3b8' :
                                        '#3b82f6',
                                '&:hover': {
                                    backgroundColor: uploadState === "success" ? '#059669' :
                                        uploadState === "uploading" ? '#94a3b8' :
                                            '#2563eb'
                                },
                                borderRadius: 2,
                                px: 2,
                                py: 0.75,
                                fontSize: 12,
                                fontWeight: 600,
                                boxShadow: uploadState === "uploading" ? 'none' : '0 2px 8px rgba(59, 130, 246, 0.3)',
                                '&:disabled': {
                                    backgroundColor: '#94a3b8',
                                    color: '#fff'
                                }
                            }}
                        >

                            <input
                                type="file"
                                accept=".xlsx, .xls, .csv"
                                onChange={handleFileChange}
                                id="excel-upload-input"
                                disabled={uploadState === "uploading"}
                                style={{ display: 'none' }}
                            />
                            {/* <input
                                type="file"
                                accept=".xlsx, .xls, .csv"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (file) {
                                        handleFileChange(e);
                                        // Trigger upload immediately using a small timeout
                                        setTimeout(() => {
                                            handleFileUploadWithAnimation();
                                        }, 50);
                                    }
                                }}
                                id="excel-upload-input"
                                disabled={uploadState === "uploading"}
                                style={{ display: 'none' }}
                            /> */}
                            {uploadState === "success" ? "Uploaded" :
                                uploadState === "uploading" ? `Uploading ${uploadProgress}%` :
                                    "Upload File"}
                        </Button>
                         )}

                        {/* Success Message */}
                        {uploadState === "success" && (
                            <Typography
                                sx={{
                                    fontSize: 12,
                                    color: '#10b981',
                                    fontWeight: 600
                                }}
                            >
                                Upload Complete!
                            </Typography>
                        )}
                    </Box>

                    {/* Refresh Button */}
                    <Button
                        onClick={onClickRefresh}
                        variant="outlined"
                        startIcon={<RefreshIcon />}
                        sx={{
                            textTransform: 'none',
                            borderRadius: 2,
                            px: 2,
                            py: 0.75,
                            fontSize: 13,
                            fontWeight: 600,
                            borderColor: '#cbd5e1',
                            color: '#64748b',
                            '&:hover': {
                                borderColor: '#3b82f6',
                                backgroundColor: '#eff6ff',
                                color: '#3b82f6'
                            }
                        }}
                    >
                        Refresh
                    </Button>
                </Box>

                <style>
                    {`
                        @keyframes scaleIn {
                            0% {
                                transform: scale(0);
                                opacity: 0;
                            }
                            50% {
                                transform: scale(1.2);
                            }
                            100% {
                                transform: scale(1);
                                opacity: 1;
                            }
                        }
                    `}
                </style>

                <div className="responsive-table">
                    <table className="custome-table">
                        <thead>
                            <tr>
                                <th>Last Upload Date & Time</th>
                                <th>Status</th>
                                <th>Upload Type</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {recordForLogTable.map((item, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{item.upload_date}</td>
                                        <td>{item.status}</td>
                                        <td>{item.upload_type}</td>
                                        <td>
                                            {item.status === "In Progress" ? (
                                                <RemoveRedEyeOutlinedIcon
                                                    className="action-icon-button-disabled"
                                                    color="disabled"
                                                />
                                            ) : item.status === "Uploaded" ? (
                                                <RemoveRedEyeOutlinedIcon
                                                    className="action-icon-button-disabled"
                                                    color="disabled"
                                                />
                                            ) : (
                                                <RemoveRedEyeOutlinedIcon
                                                    className="action-icon-button showIcon"
                                                    onClick={() => {
                                                        setCurrentErrorPage(1);
                                                        handleActionClick(item);
                                                    }}
                                                />
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                            {recordForLogTable.length === 0 && (
                                <tr>
                                    <td
                                        colSpan={4}
                                        style={{ color: "red", textAlign: "center" }}
                                    >
                                        No Data Found!
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </BoxWrapper>
            {showGrid && (
                <Grid style={{ marginTop: '20px' }} container spacing={3}>
                    <Grid item xs={12}>
                        <Box sx={{
                            padding: 3,
                            backgroundColor: '#fff',
                            borderRadius: 3,
                            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                        }}>
                            {/* Header */}
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                mb: 3,
                                pb: 2,
                                borderBottom: '2px solid #f1f5f9'
                            }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <Box sx={{
                                        width: 40,
                                        height: 40,
                                        background: 'linear-gradient(135deg, #3b82f6 0%, #6366f1 100%)',
                                        borderRadius: 2,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <AssessmentIcon sx={{ color: '#fff', fontSize: 20 }} />
                                    </Box>
                                    <Typography variant="h6" fontWeight="600" sx={{ color: '#1e293b' }}>
                                        Upload Details
                                    </Typography>
                                </Box>
                                <Button
                                    onClick={() => setShowGrid(false)}
                                    startIcon={<ClearIcon />}
                                    sx={{
                                        textTransform: 'none',
                                        color: '#64748b',
                                        '&:hover': {
                                            backgroundColor: '#fef2f2',
                                            color: '#ef4444'
                                        }
                                    }}
                                >
                                    Close
                                </Button>
                            </Box>

                            {totalRecords > 0 && (
                                <Box>
                                    {/* Stats Cards */}
                                    <Grid container spacing={2} sx={{ mb: 3, justifyContent: 'center' }}>
                                        {/* Total Records Card */}
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Box
                                                sx={{
                                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                    borderRadius: 2,
                                                    px: 1.5,                     // balanced padding (same as others)
                                                    py: 1.9,                     // ← unchanged → height stays identical
                                                    color: '#fff',
                                                    boxShadow: '0 2px 8px rgba(102,126,234,0.3)',
                                                    transition: 'transform 0.2s',
                                                    '&:hover': { transform: 'translateY(-2px)' },
                                                    display: 'flex',             // make outer Box flex container
                                                    alignItems: 'center',        // vertical center
                                                    justifyContent: 'center',    // horizontal center
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 1.2,
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <DescriptionIcon sx={{ fontSize: 22 }} />

                                                    <Typography
                                                        sx={{
                                                            fontSize: 11.5,
                                                            fontWeight: 600,
                                                            opacity: 0.95,
                                                            whiteSpace: 'nowrap',       // prevent label wrapping
                                                        }}
                                                    >
                                                        Total Records:
                                                    </Typography>

                                                    <Typography
                                                        sx={{
                                                            fontSize: '12',
                                                            fontWeight: 700,
                                                            lineHeight: 1,
                                                            ml: 0.5,                    // small spacing after label
                                                        }}
                                                    >
                                                        {totalRecords}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Grid>

                                        {/* Success Card */}
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Box
                                                sx={{
                                                    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                                    borderRadius: 2,
                                                    px: 1.5,                     // balanced padding left/right
                                                    py: 1.9,                     // ← unchanged → height stays the same
                                                    color: '#fff',
                                                    boxShadow: '0 2px 8px rgba(16,185,129,0.3)',
                                                    transition: 'transform 0.2s',
                                                    '&:hover': { transform: 'translateY(-2px)' },
                                                    display: 'flex',             // make the Box itself a flex container
                                                    alignItems: 'center',        // vertical center
                                                    justifyContent: 'center',    // horizontal center
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 1.2,
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <CheckCircleOutlineIcon sx={{ fontSize: 22 }} />  {/* slightly larger for balance */}

                                                    <Typography
                                                        sx={{
                                                            fontSize: 11.5,
                                                            fontWeight: 600,
                                                            opacity: 0.95,
                                                            whiteSpace: 'nowrap',       // prevent wrapping
                                                        }}
                                                    >
                                                        Successful:
                                                    </Typography>

                                                    <Typography
                                                        sx={{
                                                            fontSize: '12',
                                                            fontWeight: 700,
                                                            lineHeight: 1,
                                                            ml: 0.5,                    // tiny space after label
                                                        }}
                                                    >
                                                        {successfulRecords}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Grid>

                                        {/* Error Card */}
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Box
                                                sx={{
                                                    background: 'linear-gradient(135deg, #f43f5e 0%, #e11d48 100%)',
                                                    borderRadius: 2,
                                                    px: 1.5,                     // balanced left/right padding
                                                    py: 1.9,                     // ← unchanged → height remains the same
                                                    color: '#fff',
                                                    boxShadow: '0 2px 8px rgba(244,63,94,0.3)',
                                                    transition: 'transform 0.2s',
                                                    '&:hover': { transform: 'translateY(-2px)' },
                                                    display: 'flex',             // outer Box becomes flex container
                                                    alignItems: 'center',        // vertical centering
                                                    justifyContent: 'center',    // horizontal centering
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 1.2,
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <ErrorOutlineIcon sx={{ fontSize: 22 }} />  {/* slightly larger → better visual weight */}

                                                    <Typography
                                                        sx={{
                                                            fontSize: 11.5,
                                                            fontWeight: 600,
                                                            opacity: 0.95,
                                                            whiteSpace: 'nowrap',       // prevents label wrapping
                                                        }}
                                                    >
                                                        Errors:
                                                    </Typography>

                                                    <Typography
                                                        sx={{
                                                            fontSize: '12',
                                                            fontWeight: 700,
                                                            lineHeight: 1,
                                                            ml: 0.5,                    // small spacing after label
                                                        }}
                                                    >
                                                        {errorRecords}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </Grid>

                                    {/* Filter Buttons */}
                                    {/* <Box sx={{
                                        mb: 3,
                                        display: 'flex',
                                        gap: 1.5,
                                        justifyContent: 'center',
                                        flexWrap: 'wrap'
                                    }}>
                                        <Button
                                            variant="outlined"
                                            sx={{
                                                textTransform: 'none',
                                                borderRadius: 2,
                                                px: 3,
                                                py: 1,
                                                fontSize: 13,
                                                fontWeight: 600,
                                                borderColor: '#cbd5e1',
                                                color: '#64748b',
                                                '&:hover': {
                                                    borderColor: '#64748b',
                                                    backgroundColor: '#f8fafc'
                                                }
                                            }}
                                        >
                                            All Records ({totalRecords})
                                        </Button>
                                        <Button
                                            variant={currentFilter === 'success' ? 'contained' : 'outlined'}
                                            onClick={handleViewDetails}
                                            sx={{
                                                textTransform: 'none',
                                                borderRadius: 2,
                                                px: 3,
                                                py: 1,
                                                fontSize: 13,
                                                fontWeight: 600,
                                                ...(currentFilter === 'success' ? {
                                                    backgroundColor: '#10b981',
                                                    '&:hover': { backgroundColor: '#059669' }
                                                } : {
                                                    borderColor: '#a7f3d0',
                                                    color: '#059669',
                                                    '&:hover': {
                                                        borderColor: '#10b981',
                                                        backgroundColor: '#ecfdf5'
                                                    }
                                                })
                                            }}
                                        >
                                            Success ({successfulRecords})
                                        </Button>
                                        <Button
                                            variant={currentFilter === 'error' ? 'contained' : 'outlined'}
                                            onClick={handleViewErrors}
                                            sx={{
                                                textTransform: 'none',
                                                borderRadius: 2,
                                                px: 3,
                                                py: 1,
                                                fontSize: 13,
                                                fontWeight: 600,
                                                ...(currentFilter === 'error' ? {
                                                    backgroundColor: '#f43f5e',
                                                    '&:hover': { backgroundColor: '#e11d48' }
                                                } : {
                                                    borderColor: '#fecdd3',
                                                    color: '#e11d48',
                                                    '&:hover': {
                                                        borderColor: '#f43f5e',
                                                        backgroundColor: '#fef2f2'
                                                    }
                                                })
                                            }}
                                        >
                                            Errors ({errorRecords})
                                        </Button>
                                    </Box> */}

                                    {/* Data Table */}
                                    <Box sx={{
                                        height: 300,
                                        overflowY: 'auto',
                                        overflowX: 'auto',
                                        border: '1px solid #e2e8f0',
                                        borderRadius: 2
                                    }}>
                                        <MuiThemeProvider>
                                            <DataTables
                                                columns={sellerCustomerCol}
                                                data={filteredData}
                                                selectable={false}
                                                showRowHover={true}
                                                page={currentErrorPage}
                                                count={errorTotal}
                                                rowSize={errorRowsPerPage}
                                                showRowSizeControls={true}
                                                showFooterToolbar={true}
                                                onNextPageClick={handleNextPage}
                                                onPreviousPageClick={handlePreviousPage}
                                                onRowSizeChange={handleRowsPerPageChange}
                                            />
                                        </MuiThemeProvider>
                                    </Box>
                                </Box>
                            )}

                            {error && (
                                <Box sx={{
                                    mt: 2,
                                    p: 2,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1.5,
                                    backgroundColor: '#fef2f2',
                                    border: '1px solid #fecaca',
                                    borderRadius: 2
                                }}>
                                    <ErrorOutlineIcon sx={{ color: '#ef4444', fontSize: 20 }} />
                                    <Typography sx={{ color: '#dc2626', fontSize: 14 }}>
                                        {error}
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </Grid>
                </Grid>
            )}
        </>
    );
};


const COAReport = ({
    recordForTable,
    loaderForTable,
    getApiImsReport,
    gridApiRef,
    erpConnectorName,
    setZohoTriggerForDebit,
}) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [selected, setSelected] = useState([]);
    const [showFilters, setShowFilters] = useState(false);
    const [recordStatuses, setRecordStatuses] = useState({});
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "info",
    });

    const [filters, setFilters] = useState({
        searchTerm: '',
        fs_type: '',
        gst_applicable: '',
        tds_applicable: '',
        p_and_l_type: ''
    });

    const [columnWidths, setColumnWidths] = useState({
        type: 80,
        ledger_group_1: 120,
        ledger_group_2: 120,
        ledger_group_3: 120,
        ledger_group_4: 120,
        ledger_id: 100,
        ledger_code: 100,
        p_and_l_type: 180,
        ledger_name: 180,
        gst_applicable: 130,
        tds_applicable: 130,
        tcs_applicable: 130,
        gst_type_supply: 150,
        gst_nature_supply: 150,
        tds_section: 130,
        tcs_section: 130,
        hsn_code: 100,
        igst_rate: 90,
        cgst_rate: 90,
        sgst_rate: 90,
        cess_rate: 90,
        opening_balance: 120
    });

    const [bulkApply, setBulkApply] = useState({
        p_and_l_type: '',
        gst_applicable: '',
        tds_applicable: '',
        tcs_applicable: '',
        gst_type_of_supply: '',
        gst_nature_of_supply: ''
    });

    const filteredData = useMemo(() => {
        return recordForTable.filter(row => {
            const matchesSearch = !filters.searchTerm ||
                Object.values(row).some(val =>
                    String(val ?? '').toLowerCase().includes(filters.searchTerm.toLowerCase())
                );

            return (
                matchesSearch &&
                (!filters.fs_type || row.fs_type === filters.fs_type) &&
                (!filters.gst_applicable || row.gst_applicable === filters.gst_applicable) &&
                (!filters.tds_applicable || row.tds_applicable === filters.tds_applicable) &&
                (!filters.p_and_l_type || row.p_and_l_type === filters.p_and_l_type)
            );
        });
    }, [recordForTable, filters]);


const normalizeYesNo = (val) => {
    if (val === "Y") return "Yes";
    if (val === "N") return "No";
    return val || "";
};

useEffect(() => {
    const statuses = recordForTable.reduce((acc, row) => {
        acc[row.id] = {
            status: row.status || "",
            p_and_l_type: row.p_and_l_type || "",
            gst_applicable: normalizeYesNo(row.gst_applicable),
            tds_applicable: normalizeYesNo(row.tds_applicable),
            tcs_applicable: normalizeYesNo(row.tcs_applicable),
            gst_type_of_supply: row.gst_type_of_supply || "",
            gst_nature_of_supply: row.gst_nature_of_supply || "",
        };
        return acc;
    }, {});
    setRecordStatuses(statuses);
    setSelected([]);
}, [recordForTable]);

    // useEffect(() => {
    //     const statuses = recordForTable.reduce((acc, row) => {
    //         acc[row.id] = {
    //             status: row.status || "",
    //             p_and_l_type: row.p_and_l_type || "",
    //             gst_applicable: row.gst_applicable || "",
    //             tds_applicable: row.tds_applicable || "",
    //             tcs_applicable: row.tcs_applicable || "",
    //             gst_type_of_supply: row.gst_type_of_supply || "",
    //             gst_nature_of_supply: row.gst_nature_of_supply || "",
    //         };
    //         return acc;
    //     }, {});
    //     setRecordStatuses(statuses);
    //     setSelected([]);
    // }, [recordForTable]);

    const resizingColumn = useRef(null);
    const startX = useRef(0);
    const startWidth = useRef(0);

    const handleMouseDown = (e, columnKey) => {
        resizingColumn.current = columnKey;
        startX.current = e.clientX;
        startWidth.current = columnWidths[columnKey];

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
        e.preventDefault();
    };

    const ResizableHeaderCell = ({ columnKey, children, ...props }) => (
        <TableCell
            {...props}
            sx={{
                ...props.sx,
                width: columnWidths[columnKey],
                minWidth: columnWidths[columnKey],
                maxWidth: columnWidths[columnKey],
                position: 'sticky',
                top: 0,
                zIndex: 100,
                backgroundColor: '#262660', // Add solid background
                userSelect: 'none'
            }}
        >
            {children}
            <div
                onMouseDown={(e) => handleMouseDown(e, columnKey)}
                style={{
                    position: 'absolute',
                    right: 0,
                    top: 0,
                    bottom: 0,
                    width: '5px',
                    cursor: 'col-resize',
                    userSelect: 'none',
                    backgroundColor: 'transparent',
                    zIndex: 1
                }}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.3)'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
            />
        </TableCell>
    );


    const headerStyle = {
        // background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)',
        background: 'linear-gradient(135deg, #03406d 0%, #96aab9 100%)',
        color: 'white',
        fontWeight: 700,
        fontSize: '0.8rem',
        py: 0.5,
        borderBottom: '2px solid #5568d3'
    };


    const handleMouseMove = (e) => {
        if (resizingColumn.current) {
            const diff = e.clientX - startX.current;
            const newWidth = Math.max(50, startWidth.current + diff);

            setColumnWidths(prev => ({
                ...prev,
                [resizingColumn.current]: newWidth
            }));
        }
    };

    const handleMouseUp = () => {
        resizingColumn.current = null;
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    };

    const handleStatusChange = (id, field, value) => {
        setRecordStatuses(prev => ({
            ...prev,
            [id]: { ...prev[id], [field]: value }
        }));
        if (!selected.includes(id)) {
            setSelected(prev => [...prev, id]);
        }
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = filteredData.map((n) => n.id);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleFilterChange = (field, value) => {
        setFilters(prev => ({ ...prev, [field]: value }));
        setPage(0);
    };

    const handleBulkApplyAll = () => {
        Object.entries(bulkApply).forEach(([field, value]) => {
            if (value) {
                handleBulkApply(field);
            }
        });
    };

    const clearFilters = () => {
        setFilters({
            searchTerm: '',
            fs_type: '',
            gst_applicable: '',
            tds_applicable: '',
            p_and_l_type: ''
        });
    };

    const handleSubmit = async () => {
        if (selected.length === 0) {
            setSnackbar({
                open: true,
                message: "Please select at least one record to submit.",
                severity: "warning",
            });
            return;
        }

        const selectedRowsData = selected
            .map((id) => recordForTable.find((row) => row.id === id))
            .filter(Boolean);

        const payload = {
            business_entity_id: localStorage.getItem("business_entity_id"),
            records: selectedRowsData.map((row) => ({
                id: row.id,
                entity_gstn: row.entity_gstn,
                branch_name: row.branch_name,
                category: row.category,
                cwn_coa_id: row.cwn_coa_id,
                fs_type: row.fs_type,
                ledger_group_1: row.ledger_group_1,
                ledger_group_2: row.ledger_group_2,
                ledger_group_3: row.ledger_group_3,
                ledger_group_4: row.ledger_group_4,
                ledger_id: row.ledger_id,
                ledger_code: row.ledger_code,
                p_and_l_type: recordStatuses[row.id]?.p_and_l_type || row.p_and_l_type || null,
                ledger_name: row.ledger_name,
                gst_applicable: recordStatuses[row.id]?.gst_applicable || row.gst_applicable || null,
                tds_applicable: recordStatuses[row.id]?.tds_applicable || row.tds_applicable || null,
                tcs_applicable: recordStatuses[row.id]?.tcs_applicable || row.tcs_applicable || null,
                gst_type_of_supply: recordStatuses[row.id]?.gst_type_of_supply || row.gst_type_of_supply || null,
                gst_nature_of_supply: recordStatuses[row.id]?.gst_nature_of_supply || row.gst_nature_of_supply || null,
                tds_section_number: row.tds_section_number,
                tcs_section_number: row.tcs_section_number,
                hsn_code: row.hsn_code,
                igst_rate: row.igst_rate,
                cgst_rate: row.cgst_rate,
                sgst_rate: row.sgst_rate,
                cess_rate: row.cess_rate,
                opening_balance: row.opening_balance,
                status: row.status,
            })),
        };

        try {
            const res = await axios.post("/arc/update/coa", payload);
            setSnackbar({
                open: true,
                message: "Selected records submitted successfully",
                severity: "success",
            });
            if (getApiImsReport) await getApiImsReport();
            setSelected([]);
        } catch (error) {
            setSnackbar({
                open: true,
                message: error.response?.data?.message || "Error submitting records",
                severity: "error",
            });
        }
    };

    const handleBulkApply = (field) => {
        const value = bulkApply[field];
        if (!value) {
            setSnackbar({
                open: true,
                message: "Please select a value before applying",
                severity: "warning",
            });
            return;
        }
        const updatedStatuses = { ...recordStatuses };
        const affectedIds = [];
        filteredData.forEach(row => {
            updatedStatuses[row.id] = {
                ...updatedStatuses[row.id],
                [field]: value
            };
            affectedIds.push(row.id);
        });
        setRecordStatuses(updatedStatuses);
        setSelected(prev => {
            const newSet = new Set([...prev, ...affectedIds]);
            return Array.from(newSet);
        });
        setBulkApply(prev => ({
            ...prev,
            [field]: ''
        }));
        const isFiltered = Object.values(filters).some(v => !!v);
        const scopeText = isFiltered
            ? `filtered rows (${filteredData.length})`
            : `all rows (${recordForTable.length})`;
        setSnackbar({
            open: true,
            message: `Applied "${value}" to ${affectedIds.length} rows in ${scopeText}`,
            severity: "success",
        });
        console.log('Updated recordStatuses:', updatedStatuses);
        console.log('Affected IDs:', affectedIds);
    };

    const handleErpConnectorButton = () => {
        setZohoTriggerForDebit({
            messageForConnection: "Establish Connection",
            buttonColor: "red",
            zohoShowButton: true,
        });
    };

    const activeFiltersCount = Object.values(filters).filter(v => v !== '').length;

    const pAndLTypeOptions = [
        "Income",
        "Expense",
        "Expense-Purchases",
        "Expense-Freight / Carriage",
        "Expense-Power and Fuel Costs",
        "Expense-Imported goods (Including received from SEZ)",
        "Expense-Rent and Insurance Expense",
        "Expense-Goods lost, stolen, destroyed, written off or disposed of by way of gift or free samples",
        "Expense-Royalties",
        "Expense-Employee's Cost (Salaries, Wages, Bonus etc.)",
        "Expense-Conveyance charges",
        "Expense-Bank Charges",
        "Expense-Entertainment charges",
        "Expense-Stationery Expenses (including postage etc.)",
        "Expense-Repair and Maintenance",
        "Expense-Other Miscellaneous expenses",
        "Expense-Capital goods",
    ];
    const gstApplicableOptions = ["Yes", "No"];
    const tdsApplicableOptions = ["Yes", "No"];
    const tcsApplicableOptions = ["Yes", "No"];
    const gstTypeSupplyOptions = ["Services", "Goods"];
    const gstNatureofSupplyOptions = ["Taxable", "Nil", "Exempt", "Non-GST Supply"];

    return (
        <Box sx={{ width: '100%' }}>
            <Paper
                elevation={24}
                sx={{
                    borderRadius: '24px',
                    overflow: 'hidden',
                    background: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(20px)',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
                }}
            >
                <Box sx={{
                    // background: 'linear-gradient(135deg, #6d7291 0%, #9a88ad 100%)',
                    background: 'linear-gradient(135deg, #03406d 0%, #466089 100%)',
                    padding: "20px",
                    color: 'white'
                }}>

                    <Typography
                        sx={{
                            // mb: 1.5,
                            // ml: '24px',              // shorter alias for marginLeft
                            fontSize: '1.18rem',
                            fontWeight: 700,         // should work reliably here
                            // fontWeight: 'bold',   // alternative
                        }}
                    // Optional: mimic heading look if that's what you want
                    // variant="h4"          // or h3, h2, etc. – then override only what you need
                    >
                        Chart of Accounts
                    </Typography>
                    {/* <div
                        sx={{
                            mb: 1.5,
                            marginLeft: "24px",
                            fontSize: "3.18rem",       // ≈ 51px
                            fontWeight: "700 !important"         // or "bold" or 700
                            // Optional helpers while debugging:
                            // color: "red",           // make it obvious
                            // fontFamily: "Arial Black, Arial, sans-serif",
                        }}
                    >
                        Chart of Accounts
                    </div> */}
                    {/* <Typography variant="body2" sx={{ opacity: 0.9 }}>
                        Manage and configure your ledger accounts
                    </Typography> */}
                </Box>

                <Box sx={{
                    p: 2,
                    borderBottom: '1px solid #e0e0e0',
                    display: 'flex',
                    gap: 2,
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <Stack direction="row" spacing={2} sx={{ flex: 1 }}>
                        <TextField
                            size="small"
                            placeholder="Search across all columns..."
                            value={filters.searchTerm}
                            onChange={(e) => handleFilterChange('searchTerm', e.target.value)}
                            sx={{ minWidth: 300 }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon size={20} />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Button
                            variant={showFilters ? "contained" : "outlined"}
                            // startIcon={<Filter size={18} />}
                            startIcon={<FilterListIcon />}
                            onClick={() => setShowFilters(!showFilters)}
                            sx={{
                                textTransform: 'none',
                                borderRadius: '12px',
                            }}
                        >
                            Filters
                            {activeFiltersCount > 0 && (
                                <Chip
                                    label={activeFiltersCount}
                                    size="small"
                                    sx={{
                                        ml: 1,
                                        height: 20,
                                        fontSize: '0.75rem',
                                        background: 'rgba(255,255,255,0.3)'
                                    }}
                                />
                            )}
                        </Button>
                        {activeFiltersCount > 0 && (
                            <Button

                                size="small"
                                startIcon={<ClearIcon />}
                                // startIcon={<X size={16} />}
                                onClick={clearFilters}
                                sx={{ textTransform: 'none' }}
                            >
                                Clear
                            </Button>
                        )}
                    </Stack>

                    <Stack direction="row" spacing={2}>
                        {/* {erpConnectorName && localStorage.getItem("Client_ID") && (
                            <Button
                                variant="outlined"
                                onClick={handleErpConnectorButton}
                                sx={{
                                    textTransform: 'none',
                                    borderRadius: '12px',
                                }}
                            >
                                {erpConnectorName}
                            </Button>
                        )} */}
                         {canWrite("CHART OF ACCOUNTS") && (
                        <Button
                            variant="contained"
                            startIcon={<SendIcon />}
                            // startIcon={<Send size={18} />}
                            onClick={handleSubmit}
                            disabled={selected.length === 0}
                            sx={{
                                textTransform: 'none',
                                borderRadius: '12px',
                                px: 3,
                            }}
                        >
                            Submit {selected.length > 0 && `(${selected.length})`}
                        </Button>
                         )}
                    </Stack>
                </Box>

                <Collapse in={showFilters}>
                    <Box sx={{
                        p: 3,
                        borderBottom: '1px solid #e0e0e0',
                        background: '#f8f9fa',
                    }}>
                        {/* <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 2 }}>
                            Filter Data
                        </Typography>
                        <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                            gap: 2,
                            mb: 3
                        }}>
                            <FormControl size="small" fullWidth>
                                <InputLabel>FS Type</InputLabel>
                                <Select
                                    value={filters.fs_type}
                                    label="FS Type"
                                    onChange={(e) => handleFilterChange('fs_type', e.target.value)}
                                >
                                    <MenuItem value="">All</MenuItem>
                                    <MenuItem value="PL">PL</MenuItem>
                                    <MenuItem value="BS">BS</MenuItem>
                                </Select>
                            </FormControl>

                            <FormControl size="small" fullWidth>
                                <InputLabel>P&L Type</InputLabel>
                                <Select
                                    value={filters.p_and_l_type}
                                    label="P&L Type"
                                    onChange={(e) => handleFilterChange('p_and_l_type', e.target.value)}
                                >
                                    <MenuItem value="">All</MenuItem>
                                    {pAndLTypeOptions.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl size="small" fullWidth>
                                <InputLabel>GST Applicable</InputLabel>
                                <Select
                                    value={filters.gst_applicable}
                                    label="GST Applicable"
                                    onChange={(e) => handleFilterChange('gst_applicable', e.target.value)}
                                >
                                    <MenuItem value="">All</MenuItem>
                                    <MenuItem value="Yes">Yes</MenuItem>
                                    <MenuItem value="No">No</MenuItem>
                                </Select>
                            </FormControl>

                            <FormControl size="small" fullWidth>
                                <InputLabel>TDS Applicable</InputLabel>
                                <Select
                                    value={filters.tds_applicable}
                                    label="TDS Applicable"
                                    onChange={(e) => handleFilterChange('tds_applicable', e.target.value)}
                                >
                                    <MenuItem value="">All</MenuItem>
                                    <MenuItem value="Yes">Yes</MenuItem>
                                    <MenuItem value="No">No</MenuItem>
                                </Select>
                            </FormControl>
                        </Box> */}

                        {/* <Divider sx={{ my: 2 }} /> */}

                        <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 2 }}>
                            Bulk Apply to Filtered Rows ({filteredData.length} rows)
                        </Typography>


                        <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                            gap: 2
                        }}>
                            <FormControl size="small" fullWidth>
                                <InputLabel>P&L Type</InputLabel>
                                <Select
                                    value={bulkApply.p_and_l_type}
                                    label="P&L Type"
                                    onChange={(e) => setBulkApply(prev => ({ ...prev, p_and_l_type: e.target.value }))}
                                >
                                    <MenuItem value="">Select</MenuItem>
                                    {pAndLTypeOptions.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl size="small" fullWidth>
                                <InputLabel>GST Applicable</InputLabel>
                                <Select
                                    value={bulkApply.gst_applicable}
                                    label="GST Applicable"
                                    onChange={(e) => setBulkApply(prev => ({ ...prev, gst_applicable: e.target.value }))}
                                >
                                    <MenuItem value="">Select</MenuItem>
                                    {gstApplicableOptions.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl size="small" fullWidth>
                                <InputLabel>TDS Applicable</InputLabel>
                                <Select
                                    value={bulkApply.tds_applicable}
                                    label="TDS Applicable"
                                    onChange={(e) => setBulkApply(prev => ({ ...prev, tds_applicable: e.target.value }))}
                                >
                                    <MenuItem value="">Select</MenuItem>
                                    {tdsApplicableOptions.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl size="small" fullWidth>
                                <InputLabel>TCS Applicable</InputLabel>
                                <Select
                                    value={bulkApply.tcs_applicable}
                                    label="TCS Applicable"
                                    onChange={(e) => setBulkApply(prev => ({ ...prev, tcs_applicable: e.target.value }))}
                                >
                                    <MenuItem value="">Select</MenuItem>
                                    {tcsApplicableOptions.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl size="small" fullWidth>
                                <InputLabel>GST Type Supply</InputLabel>
                                <Select
                                    value={bulkApply.gst_type_of_supply}
                                    label="GST Type Supply"
                                    onChange={(e) => setBulkApply(prev => ({ ...prev, gst_type_of_supply: e.target.value }))}
                                >
                                    <MenuItem value="">Select</MenuItem>
                                    {gstTypeSupplyOptions.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <FormControl size="small" fullWidth>
                                    <InputLabel>GST Nature Supply</InputLabel>
                                    <Select
                                        value={bulkApply.gst_nature_of_supply}
                                        label="GST Nature Supply"
                                        onChange={(e) => setBulkApply(prev => ({ ...prev, gst_nature_of_supply: e.target.value }))}
                                    >
                                        <MenuItem value="">Select</MenuItem>
                                        {gstNatureofSupplyOptions.map(opt => (
                                            <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                            </Box>
                            <Button
                                variant="contained"
                                size="small"
                                onClick={handleBulkApplyAll}
                                disabled={!Object.values(bulkApply).some(val => val !== '')}
                                sx={{ minWidth: 'auto', px: 2, whiteSpace: 'nowrap' }}
                            >
                                Apply All Changes
                            </Button>
                        </Box>

                        {/* <Box sx={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                            gap: 2
                        }}>
                            <FormControl size="small" fullWidth>
                                <InputLabel>P&L Type</InputLabel>
                                <Select
                                    value={bulkApply.p_and_l_type}
                                    label="P&L Type"
                                    onChange={(e) => setBulkApply(prev => ({ ...prev, p_and_l_type: e.target.value }))}
                                >
                                    <MenuItem value="">Select</MenuItem>
                                    {pAndLTypeOptions.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl size="small" fullWidth>
                                <InputLabel>GST Applicable</InputLabel>
                                <Select
                                    value={bulkApply.gst_applicable}
                                    label="GST Applicable"
                                    onChange={(e) => setBulkApply(prev => ({ ...prev, gst_applicable: e.target.value }))}
                                >
                                    <MenuItem value="">Select</MenuItem>
                                    {gstApplicableOptions.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl size="small" fullWidth>
                                <InputLabel>TDS Applicable</InputLabel>
                                <Select
                                    value={bulkApply.tds_applicable}
                                    label="TDS Applicable"
                                    onChange={(e) => setBulkApply(prev => ({ ...prev, tds_applicable: e.target.value }))}
                                >
                                    <MenuItem value="">Select</MenuItem>
                                    {tdsApplicableOptions.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl size="small" fullWidth>
                                <InputLabel>TCS Applicable</InputLabel>
                                <Select
                                    value={bulkApply.tcs_applicable}
                                    label="TCS Applicable"
                                    onChange={(e) => setBulkApply(prev => ({ ...prev, tcs_applicable: e.target.value }))}
                                >
                                    <MenuItem value="">Select</MenuItem>
                                    {tcsApplicableOptions.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl size="small" fullWidth>
                                <InputLabel>GST Type Supply</InputLabel>
                                <Select
                                    value={bulkApply.gst_type_of_supply}
                                    label="GST Type Supply"
                                    onChange={(e) => setBulkApply(prev => ({ ...prev, gst_type_of_supply: e.target.value }))}
                                >
                                    <MenuItem value="">Select</MenuItem>
                                    {gstTypeSupplyOptions.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl size="small" fullWidth>
                                <InputLabel>GST Nature Supply</InputLabel>
                                <Select
                                    value={bulkApply.gst_nature_of_supply}
                                    label="GST Nature Supply"
                                    onChange={(e) => setBulkApply(prev => ({ ...prev, gst_nature_of_supply: e.target.value }))}
                                >
                                    <MenuItem value="">Select</MenuItem>
                                    {gstNatureofSupplyOptions.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box> */}

                        {/* <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                variant="contained"
                                onClick={handleBulkApplyAll}
                                disabled={!Object.values(bulkApply).some(val => val !== '')}
                            >
                                Apply All Changes
                            </Button>
                        </Box> */}
                    </Box>
                </Collapse>

                {/* Table with reduced height and smaller font */}
                <TableContainer sx={{ maxHeight: 400, overflowX: 'auto', overflowY: 'auto' }}>
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                <ResizableHeaderCell columnKey="type" sx={headerStyle}>Type</ResizableHeaderCell>
                                <ResizableHeaderCell columnKey="ledger_group_1" sx={headerStyle}>Ledger Group 1</ResizableHeaderCell>
                                <ResizableHeaderCell columnKey="ledger_group_2" sx={headerStyle}>Ledger Group 2</ResizableHeaderCell>
                                <ResizableHeaderCell columnKey="ledger_group_3" sx={headerStyle}>Ledger Group 3</ResizableHeaderCell>
                                <ResizableHeaderCell columnKey="ledger_group_4" sx={headerStyle}>Ledger Group 4</ResizableHeaderCell>
                                {/* <ResizableHeaderCell columnKey="ledger_id" sx={headerStyle}>Ledger ID</ResizableHeaderCell>
                                <ResizableHeaderCell columnKey="ledger_code" sx={headerStyle}>Ledger Code</ResizableHeaderCell> */}
                                <ResizableHeaderCell columnKey="p_and_l_type" sx={headerStyle}>P&L Type</ResizableHeaderCell>
                                <ResizableHeaderCell columnKey="ledger_name" sx={headerStyle}>Ledger Name</ResizableHeaderCell>
                                <ResizableHeaderCell columnKey="gst_applicable" sx={headerStyle}>RCM Applicable</ResizableHeaderCell>
                                <ResizableHeaderCell columnKey="tds_applicable" sx={headerStyle}>ITC Applicable</ResizableHeaderCell>
                                <ResizableHeaderCell columnKey="gst_applicable" sx={headerStyle}>GST Applicable</ResizableHeaderCell>
                                <ResizableHeaderCell columnKey="tds_applicable" sx={headerStyle}>TDS Applicable</ResizableHeaderCell>
                                <ResizableHeaderCell columnKey="tcs_applicable" sx={headerStyle}>TCS Applicable</ResizableHeaderCell>
                                <ResizableHeaderCell columnKey="gst_type_supply" sx={headerStyle}>GST Type Supply</ResizableHeaderCell>
                                <ResizableHeaderCell columnKey="gst_nature_supply" sx={headerStyle}>GST Nature Supply</ResizableHeaderCell>
                                <ResizableHeaderCell columnKey="tds_section" sx={headerStyle}>TDS Section Number</ResizableHeaderCell>
                                <ResizableHeaderCell columnKey="tcs_section" sx={headerStyle}>TCS Section Number</ResizableHeaderCell>
                                <ResizableHeaderCell columnKey="hsn_code" sx={headerStyle}>HSN Code</ResizableHeaderCell>
                                <ResizableHeaderCell columnKey="igst_rate" sx={headerStyle}>IGST Rate</ResizableHeaderCell>
                                <ResizableHeaderCell columnKey="cgst_rate" sx={headerStyle}>CGST Rate</ResizableHeaderCell>
                                <ResizableHeaderCell columnKey="sgst_rate" sx={headerStyle}>SGST Rate</ResizableHeaderCell>
                                <ResizableHeaderCell columnKey="cess_rate" sx={headerStyle}>CESS Rate</ResizableHeaderCell>
                                <ResizableHeaderCell columnKey="opening_balance" sx={headerStyle}>Opening Balance</ResizableHeaderCell>
                            </TableRow>
                        </TableHead>
                        <TableBody
                            sx={{

                                overflowY: 'auto',

                            }}
                        >
                            {loaderForTable ? (
                                <TableRow>
                                    <TableCell colSpan={22} align="center" sx={{ py: 6 }}>
                                        <Typography fontSize="0.85rem">Loading...</Typography>
                                    </TableCell>
                                </TableRow>
                            ) : filteredData.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={22} align="center" sx={{ py: 6 }}>
                                        <Typography fontSize="0.85rem">No data available</Typography>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                filteredData
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row) => {
                                        const isItemSelected = selected.includes(row.id);
                                        return (
                                            <TableRow
                                                key={row.id}
                                                hover
                                                onClick={(event) => handleClick(event, row.id)}
                                                selected={isItemSelected}
                                                sx={{
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s',
                                                    '&:hover': {
                                                        background: 'linear-gradient(90deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)',
                                                        transform: 'scale(1.002)',
                                                    },
                                                    '&.Mui-selected': {
                                                        background: 'linear-gradient(90deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
                                                        '&:hover': {
                                                            background: 'linear-gradient(90deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%)',
                                                        }
                                                    }
                                                }}
                                            >
                                                <TableCell sx={{ fontSize: '0.8rem', width: columnWidths.type }}>{row.fs_type}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem', width: columnWidths.ledger_group_1 }}>{row.ledger_group_1}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem', width: columnWidths.ledger_group_2 }}>{row.ledger_group_2}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem', width: columnWidths.ledger_group_3 }}>{row.ledger_group_3}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem', width: columnWidths.ledger_group_4 }}>{row.ledger_group_4}</TableCell>
                                                {/* <TableCell sx={{ fontSize: '0.8rem', width: columnWidths.ledger_id }}>{row.ledger_id}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem', width: columnWidths.ledger_code }}>{row.ledger_code}</TableCell> */}
                                                <TableCell onClick={e => e.stopPropagation()} sx={{ fontSize: '0.8rem', width: columnWidths.p_and_l_type }}>
                                                    {row.fs_type === "BS" ? (
                                                        <Typography variant="body2" color="text.secondary" fontSize="0.8rem">-</Typography>
                                                    ) : (
                                                        <FormControl size="small" fullWidth>
                                                            <Select
                                                                value={recordStatuses[row.id]?.p_and_l_type || ""}
                                                                onChange={(e) => handleStatusChange(row.id, "p_and_l_type", e.target.value)}
                                                                sx={{ fontSize: '0.8rem' }}
                                                            >
                                                                <MenuItem value="" disabled>Select</MenuItem>
                                                                {pAndLTypeOptions.map((opt) => (
                                                                    <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    )}
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: 600, fontSize: '0.8rem', width: columnWidths.ledger_name }}>{row.ledger_name}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem', width: columnWidths.rcm_applicability }}>{row.rcm_applicability}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem', width: columnWidths.itc_eligibility }}>{row.itc_eligibility}</TableCell>

                                                <TableCell onClick={e => e.stopPropagation()} sx={{ fontSize: '0.8rem', width: columnWidths.gst_applicable }}>
                                                    <FormControl size="small" fullWidth>
                                                        <Select
                                                            value={recordStatuses[row.id]?.gst_applicable || ""}
                                                            onChange={(e) => handleStatusChange(row.id, "gst_applicable", e.target.value)}
                                                            sx={{ fontSize: '0.8rem' }}
                                                        >
                                                            <MenuItem value="" disabled>Select</MenuItem>
                                                            {gstApplicableOptions.map(opt => (
                                                                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell onClick={e => e.stopPropagation()} sx={{ fontSize: '0.8rem', width: columnWidths.tds_applicable }}>
                                                    <FormControl size="small" fullWidth>
                                                        <Select
                                                            value={recordStatuses[row.id]?.tds_applicable || ""}
                                                            onChange={(e) => handleStatusChange(row.id, "tds_applicable", e.target.value)}
                                                            sx={{ fontSize: '0.8rem' }}
                                                        >
                                                            <MenuItem value="" disabled>Select</MenuItem>
                                                            {tdsApplicableOptions.map(opt => (
                                                                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell onClick={e => e.stopPropagation()} sx={{ fontSize: '0.8rem', width: columnWidths.tcs_applicable }}>
                                                    <FormControl size="small" fullWidth>
                                                        <Select
                                                            value={recordStatuses[row.id]?.tcs_applicable || ""}
                                                            onChange={(e) => handleStatusChange(row.id, "tcs_applicable", e.target.value)}
                                                            sx={{ fontSize: '0.8rem' }}
                                                        >
                                                            <MenuItem value="" disabled>Select</MenuItem>
                                                            {tcsApplicableOptions.map(opt => (
                                                                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell onClick={e => e.stopPropagation()} sx={{ fontSize: '0.8rem', width: columnWidths.gst_type_supply }}>
                                                    <FormControl size="small" fullWidth>
                                                        <Select
                                                            value={recordStatuses[row.id]?.gst_type_of_supply || ""}
                                                            onChange={(e) => handleStatusChange(row.id, "gst_type_of_supply", e.target.value)}
                                                            sx={{ fontSize: '0.8rem' }}
                                                        >
                                                            <MenuItem value="" disabled>Select</MenuItem>
                                                            {gstTypeSupplyOptions.map(opt => (
                                                                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell onClick={e => e.stopPropagation()} sx={{ fontSize: '0.8rem', width: columnWidths.gst_nature_supply }}>
                                                    <FormControl size="small" fullWidth>
                                                        <Select
                                                            value={recordStatuses[row.id]?.gst_nature_of_supply || ""}
                                                            onChange={(e) => handleStatusChange(row.id, "gst_nature_of_supply", e.target.value)}
                                                            sx={{ fontSize: '0.8rem' }}
                                                        >
                                                            <MenuItem value="" disabled>Select</MenuItem>
                                                            {gstNatureofSupplyOptions.map(opt => (
                                                                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem', width: columnWidths.tds_section }}>{row.tds_section_number}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem', width: columnWidths.tcs_section }}>{row.tcs_section_number}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem', width: columnWidths.hsn_code }}>{row.hsn_code}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem', width: columnWidths.igst_rate }}>{row.igst_rate}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem', width: columnWidths.cgst_rate }}>{row.cgst_rate}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem', width: columnWidths.sgst_rate }}>{row.sgst_rate}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem', width: columnWidths.cess_rate }}>{row.cess_rate}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem', width: columnWidths.opening_balance }}>{row.opening_balance}</TableCell>
                                            </TableRow>
                                        );
                                    })
                            )}
                        </TableBody>
                    </Table>
                    {/* <Table stickyHeader size="small" sx={{ tableLayout: 'fixed', width: '100%' }}>
                        <colgroup>
                            <col style={{ width: '80px' }} />
                            <col style={{ width: '120px' }} />
                            <col style={{ width: '120px' }} />
                            <col style={{ width: '120px' }} />
                            <col style={{ width: '120px' }} />
                            <col style={{ width: '100px' }} />
                            <col style={{ width: '100px' }} />
                            <col style={{ width: '180px' }} />
                            <col style={{ width: '180px' }} />
                            <col style={{ width: '130px' }} />
                            <col style={{ width: '130px' }} />
                            <col style={{ width: '130px' }} />
                            <col style={{ width: '150px' }} />
                            <col style={{ width: '150px' }} />
                            <col style={{ width: '130px' }} />
                            <col style={{ width: '130px' }} />
                            <col style={{ width: '100px' }} />
                            <col style={{ width: '90px' }} />
                            <col style={{ width: '90px' }} />
                            <col style={{ width: '90px' }} />
                            <col style={{ width: '90px' }} />
                            <col style={{ width: '120px' }} />
                        </colgroup>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>Type</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>Ledger Group 1</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>Ledger Group 2</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>Ledger Group 3</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>Ledger Group 4</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>Ledger ID</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>Ledger Code</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>P&L Type</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>Ledger Name</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>GST Applicable</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>TDS Applicable</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>TCS Applicable</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>GST Type Supply</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>GST Nature Supply</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>TDS Section Number</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>TCS Section Number</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>HSN Code</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>IGST Rate</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>CGST Rate</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>SGST Rate</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>CESS Rate</TableCell>
                                <TableCell sx={{ background: 'linear-gradient(135deg, #262660 0%, #8d8a91 100%)', color: 'white', fontWeight: 700, fontSize: '0.8rem', py: 1.5, borderBottom: '2px solid #5568d3' }}>Opening Balance</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loaderForTable ? (
                                <TableRow>
                                    <TableCell colSpan={22} align="center" sx={{ py: 6 }}>
                                        <Typography fontSize="0.85rem">Loading...</Typography>
                                    </TableCell>
                                </TableRow>
                            ) : filteredData.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={22} align="center" sx={{ py: 6 }}>
                                        <Typography fontSize="0.85rem">No data available</Typography>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                filteredData
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row) => {
                                        const isItemSelected = selected.includes(row.id);
                                        return (
                                            <TableRow
                                                key={row.id}
                                                hover
                                                onClick={(event) => handleClick(event, row.id)}
                                                selected={isItemSelected}
                                                sx={{
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s',
                                                    '&:hover': {
                                                        background: 'linear-gradient(90deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)',
                                                        transform: 'scale(1.002)',
                                                    },
                                                    '&.Mui-selected': {
                                                        background: 'linear-gradient(90deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
                                                        '&:hover': {
                                                            background: 'linear-gradient(90deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%)',
                                                        }
                                                    }
                                                }}
                                            >
                                                <TableCell sx={{ fontSize: '0.8rem' }}>{row.fs_type}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem' }}>{row.ledger_group_1}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem' }}>{row.ledger_group_2}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem' }}>{row.ledger_group_3}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem' }}>{row.ledger_group_4}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem' }}>{row.ledger_id}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem' }}>{row.ledger_code}</TableCell>
                                                <TableCell onClick={e => e.stopPropagation()} sx={{ fontSize: '0.8rem' }}>
                                                    {row.fs_type === "BS" ? (
                                                        <Typography variant="body2" color="text.secondary" fontSize="0.8rem">-</Typography>
                                                    ) : (
                                                        <FormControl size="small" fullWidth>
                                                            <Select
                                                                value={recordStatuses[row.id]?.p_and_l_type || ""}
                                                                onChange={(e) => handleStatusChange(row.id, "p_and_l_type", e.target.value)}
                                                                sx={{ fontSize: '0.8rem' }}
                                                            >
                                                                <MenuItem value="" disabled>Select</MenuItem>
                                                                {pAndLTypeOptions.map((opt) => (
                                                                    <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    )}
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: 600, fontSize: '0.8rem' }}>{row.ledger_name}</TableCell>

                                                <TableCell onClick={e => e.stopPropagation()} sx={{ fontSize: '0.8rem' }}>
                                                    <FormControl size="small" fullWidth>
                                                        <Select
                                                            value={recordStatuses[row.id]?.gst_applicable || ""}
                                                            onChange={(e) => handleStatusChange(row.id, "gst_applicable", e.target.value)}
                                                            sx={{ fontSize: '0.8rem' }}
                                                        >
                                                            <MenuItem value="" disabled>Select</MenuItem>
                                                            {gstApplicableOptions.map(opt => (
                                                                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </TableCell>

                                                <TableCell onClick={e => e.stopPropagation()} sx={{ fontSize: '0.8rem' }}>
                                                    <FormControl size="small" fullWidth>
                                                        <Select
                                                            value={recordStatuses[row.id]?.tds_applicable || ""}
                                                            onChange={(e) => handleStatusChange(row.id, "tds_applicable", e.target.value)}
                                                            sx={{ fontSize: '0.8rem' }}
                                                        >
                                                            <MenuItem value="" disabled>Select</MenuItem>
                                                            {tdsApplicableOptions.map(opt => (
                                                                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </TableCell>

                                                <TableCell onClick={e => e.stopPropagation()} sx={{ fontSize: '0.8rem' }}>
                                                    <FormControl size="small" fullWidth>
                                                        <Select
                                                            value={recordStatuses[row.id]?.tcs_applicable || ""}
                                                            onChange={(e) => handleStatusChange(row.id, "tcs_applicable", e.target.value)}
                                                            sx={{ fontSize: '0.8rem' }}
                                                        >
                                                            <MenuItem value="" disabled>Select</MenuItem>
                                                            {tcsApplicableOptions.map(opt => (
                                                                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </TableCell>

                                                <TableCell onClick={e => e.stopPropagation()} sx={{ fontSize: '0.8rem' }}>
                                                    <FormControl size="small" fullWidth>
                                                        <Select
                                                            value={recordStatuses[row.id]?.gst_type_of_supply || ""}
                                                            onChange={(e) => handleStatusChange(row.id, "gst_type_of_supply", e.target.value)}
                                                            sx={{ fontSize: '0.8rem' }}
                                                        >
                                                            <MenuItem value="" disabled>Select</MenuItem>
                                                            {gstTypeSupplyOptions.map(opt => (
                                                                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </TableCell>

                                                <TableCell onClick={e => e.stopPropagation()} sx={{ fontSize: '0.8rem' }}>
                                                    <FormControl size="small" fullWidth>
                                                        <Select
                                                            value={recordStatuses[row.id]?.gst_nature_of_supply || ""}
                                                            onChange={(e) => handleStatusChange(row.id, "gst_nature_of_supply", e.target.value)}
                                                            sx={{ fontSize: '0.8rem' }}
                                                        >
                                                            <MenuItem value="" disabled>Select</MenuItem>
                                                            {gstNatureofSupplyOptions.map(opt => (
                                                                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </TableCell>

                                                <TableCell sx={{ fontSize: '0.8rem' }}>{row.tds_section_number}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem' }}>{row.tcs_section_number}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem' }}>{row.hsn_code}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem' }}>{row.igst_rate}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem' }}>{row.cgst_rate}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem' }}>{row.sgst_rate}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem' }}>{row.cess_rate}</TableCell>
                                                <TableCell sx={{ fontSize: '0.8rem' }}>{row.opening_balance}</TableCell>
                                            </TableRow>
                                        );
                                    })
                            )}
                        </TableBody>
                    </Table> */}
                </TableContainer>

                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    component="div"
                    count={filteredData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    sx={{
                        borderTop: '1px solid #e0e0e0',
                        background: '#f8f9fa'
                    }}
                />
            </Paper>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                    severity={snackbar.severity}
                    sx={{
                        borderRadius: '12px',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.2)'
                    }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    );
};

// const COAReport = ({
//     recordForTable,
//     loaderForTable,
//     getApiImsReport,
//     gridApiRef,
//     erpConnectorName,
//     setZohoTriggerForDebit
// }) => {
//     const [page, setPage] = useState(0);
//     const [rowsPerPage, setRowsPerPage] = useState(10);
//     const [selected, setSelected] = useState([]);
//     const [showFilters, setShowFilters] = useState(false);
//     const [recordStatuses, setRecordStatuses] = useState({});
//     const [snackbar, setSnackbar] = useState({
//         open: false,
//         message: "",
//         severity: "info",
//     });

//     // Filter states
//     const [filters, setFilters] = useState({
//         searchTerm: '',
//         fs_type: '',
//         gst_applicable: '',
//         tds_applicable: '',
//         p_and_l_type: ''
//     });

//     useEffect(() => {
//         const statuses = recordForTable.reduce((acc, row) => {
//             acc[row.id] = {
//                 status: row.status || "",
//                 p_and_l_type: row.p_and_l_type || "",
//                 gst_applicable: row.gst_applicable || "",
//                 tds_applicable: row.tds_applicable || "",
//                 tcs_applicable: row.tcs_applicable || "",
//                 gst_type_of_supply: row.gst_type_of_supply || "",
//                 gst_nature_of_supply: row.gst_nature_of_supply || "",
//             };
//             return acc;
//         }, {});
//         setRecordStatuses(statuses);
//         setSelected([]);
//     }, [recordForTable]);

//     const handleStatusChange = (id, field, value) => {
//         setRecordStatuses(prev => ({
//             ...prev,
//             [id]: { ...prev[id], [field]: value }
//         }));
//         if (!selected.includes(id)) {
//             setSelected(prev => [...prev, id]);
//         }
//     };

//     const handleSelectAllClick = (event) => {
//         if (event.target.checked) {
//             const newSelected = filteredData.map((n) => n.id);
//             setSelected(newSelected);
//             return;
//         }
//         setSelected([]);
//     };

//     const handleClick = (event, id) => {
//         const selectedIndex = selected.indexOf(id);
//         let newSelected = [];

//         if (selectedIndex === -1) {
//             newSelected = newSelected.concat(selected, id);
//         } else if (selectedIndex === 0) {
//             newSelected = newSelected.concat(selected.slice(1));
//         } else if (selectedIndex === selected.length - 1) {
//             newSelected = newSelected.concat(selected.slice(0, -1));
//         } else if (selectedIndex > 0) {
//             newSelected = newSelected.concat(
//                 selected.slice(0, selectedIndex),
//                 selected.slice(selectedIndex + 1),
//             );
//         }

//         setSelected(newSelected);
//     };

//     const handleChangePage = (event, newPage) => {
//         setPage(newPage);
//     };

//     const handleChangeRowsPerPage = (event) => {
//         setRowsPerPage(parseInt(event.target.value, 10));
//         setPage(0);
//     };

//     const handleFilterChange = (field, value) => {
//         setFilters(prev => ({ ...prev, [field]: value }));
//         setPage(0);
//     };
//      const [bulkApply, setBulkApply] = useState({
//         p_and_l_type: '',
//         gst_applicable: '',
//         tds_applicable: '',
//         tcs_applicable: '',
//         gst_type_of_supply: '',
//         gst_nature_of_supply: ''
//     });

//     const clearFilters = () => {
//         setFilters({
//             searchTerm: '',
//             fs_type: '',
//             gst_applicable: '',
//             tds_applicable: '',
//             p_and_l_type: ''
//         });
//     };

//     const handleSubmit = async () => {
//         if (selected.length === 0) {
//             setSnackbar({
//                 open: true,
//                 message: "Please select at least one record to submit.",
//                 severity: "warning",
//             });
//             return;
//         }

//         const selectedRowsData = selected
//             .map((id) => recordForTable.find((row) => row.id === id))
//             .filter(Boolean);

//         const payload = {
//             business_entity_id: localStorage.getItem("business_entity_id"),
//             records: selectedRowsData.map((row) => ({
//                 id: row.id,
//                 entity_gstn: row.entity_gstn,
//                 branch_name: row.branch_name,
//                 category: row.category,
//                 cwn_coa_id: row.cwn_coa_id,
//                 fs_type: row.fs_type,
//                 ledger_group_1: row.ledger_group_1,
//                 ledger_group_2: row.ledger_group_2,
//                 ledger_group_3: row.ledger_group_3,
//                 ledger_group_4: row.ledger_group_4,
//                 ledger_id: row.ledger_id,
//                 ledger_code: row.ledger_code,
//                 p_and_l_type: recordStatuses[row.id]?.p_and_l_type || row.p_and_l_type || null,
//                 ledger_name: row.ledger_name,
//                 gst_applicable: recordStatuses[row.id]?.gst_applicable || row.gst_applicable || null,
//                 tds_applicable: recordStatuses[row.id]?.tds_applicable || row.tds_applicable || null,
//                 tcs_applicable: recordStatuses[row.id]?.tcs_applicable || row.tcs_applicable || null,
//                 gst_type_of_supply: recordStatuses[row.id]?.gst_type_of_supply || row.gst_type_of_supply || null,
//                 gst_nature_of_supply: recordStatuses[row.id]?.gst_nature_of_supply || row.gst_nature_of_supply || null,
//                 tds_section_number: row.tds_section_number,
//                 tcs_section_number: row.tcs_section_number,
//                 hsn_code: row.hsn_code,
//                 igst_rate: row.igst_rate,
//                 cgst_rate: row.cgst_rate,
//                 sgst_rate: row.sgst_rate,
//                 cess_rate: row.cess_rate,
//                 opening_balance: row.opening_balance,
//                 status: row.status,
//             })),
//         };

//         try {
//             const res = await axios.post("/arc/update/coa", payload);
//             setSnackbar({
//                 open: true,
//                 message: "Selected records submitted successfully",
//                 severity: "success",
//             });
//             if (getApiImsReport) await getApiImsReport();
//             setSelected([]);
//         } catch (error) {
//             setSnackbar({
//                 open: true,
//                 message: error.response?.data?.message || "Error submitting records",
//                 severity: "error",
//             });
//         }
//     };

//         const handleBulkApply = (field) => {
//         const value = bulkApply[field];
//         if (!value) return;

//         const updatedStatuses = { ...recordStatuses };
//         const affectedIds = [];

//         filteredData.forEach(row => {
//             // Only apply to PL type rows if the field is p_and_l_type
//             if (field === 'p_and_l_type' && row.fs_type !== 'PL') {
//                 return;
//             }

//             updatedStatuses[row.id] = {
//                 ...updatedStatuses[row.id],
//                 [field]: value
//             };
//             affectedIds.push(row.id);
//         });

//         setRecordStatuses(updatedStatuses);

//         // Add all affected rows to selection
//         setSelected(prev => {
//             const newSelected = new Set([...prev, ...affectedIds]);
//             return Array.from(newSelected);
//         });

//         setSnackbar({
//             open: true,
//             message: `Applied "${value}" to ${affectedIds.length} filtered rows`,
//             severity: "success",
//         });
//     };

//     const handleErpConnectorButton = () => {
//         setZohoTriggerForDebit({
//             messageForConnection: "Establish Connection",
//             buttonColor: "red",
//             zohoShowButton: true,
//         });
//     };

//     // Filtered data logic
//     const filteredData = recordForTable.filter(row => {
//         const matchesSearch = !filters.searchTerm ||
//             Object.values(row).some(val =>
//                 String(val).toLowerCase().includes(filters.searchTerm.toLowerCase())
//             );

//         const matchesFsType = !filters.fs_type || row.fs_type === filters.fs_type;
//         const matchesGst = !filters.gst_applicable || row.gst_applicable === filters.gst_applicable;
//         const matchesTds = !filters.tds_applicable || row.tds_applicable === filters.tds_applicable;
//         const matchesPnL = !filters.p_and_l_type || row.p_and_l_type === filters.p_and_l_type;

//         return matchesSearch && matchesFsType && matchesGst && matchesTds && matchesPnL;
//     });

//     const activeFiltersCount = Object.values(filters).filter(v => v !== '').length;

//     return (
//         <Box sx={{ width: '100%' }}>
//             <Paper
//                 elevation={24}
//                 sx={{
//                     borderRadius: '24px',
//                     overflow: 'hidden',
//                     background: 'rgba(255, 255, 255, 0.95)',
//                     backdropFilter: 'blur(20px)',
//                     boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
//                 }}
//             >
//                 {/* Header */}
//                 <Box sx={{
//                     background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//                     p: 3,
//                     color: 'white'
//                 }}>
//                     <Typography variant="h4" fontWeight="700" sx={{ mb: 1 }}>
//                         Chart of Accounts
//                     </Typography>
//                     <Typography variant="body2" sx={{ opacity: 0.9 }}>
//                         Manage and configure your ledger accounts
//                     </Typography>
//                 </Box>

//                 {/* Toolbar */}
//                 <Box sx={{
//                     p: 2,
//                     borderBottom: '1px solid #e0e0e0',
//                     display: 'flex',
//                     gap: 2,
//                     flexWrap: 'wrap',
//                     alignItems: 'center',
//                     justifyContent: 'space-between'
//                 }}>
//                     <Stack direction="row" spacing={2} sx={{ flex: 1 }}>
//                         <TextField
//                             size="small"
//                             placeholder="Search across all columns..."
//                             value={filters.searchTerm}
//                             onChange={(e) => handleFilterChange('searchTerm', e.target.value)}
//                             sx={{ minWidth: 300 }}
//                             InputProps={{
//                                 startAdornment: (
//                                     <InputAdornment position="start">
//                                         <Search size={20} />
//                                     </InputAdornment>
//                                 ),
//                             }}
//                         />

//                         <Button
//                             variant={showFilters ? "contained" : "outlined"}
//                             startIcon={<Filter size={18} />}
//                             onClick={() => setShowFilters(!showFilters)}
//                             sx={{
//                                 textTransform: 'none',
//                                 borderRadius: '12px',
//                             }}
//                         >
//                             Filters
//                             {activeFiltersCount > 0 && (
//                                 <Chip
//                                     label={activeFiltersCount}
//                                     size="small"
//                                     sx={{
//                                         ml: 1,
//                                         height: 20,
//                                         fontSize: '0.75rem',
//                                         background: 'rgba(255,255,255,0.3)'
//                                     }}
//                                 />
//                             )}
//                         </Button>

//                         {activeFiltersCount > 0 && (
//                             <Button
//                                 size="small"
//                                 startIcon={<X size={16} />}
//                                 onClick={clearFilters}
//                                 sx={{ textTransform: 'none' }}
//                             >
//                                 Clear
//                             </Button>
//                         )}
//                     </Stack>

//                     <Stack direction="row" spacing={2}>
//                         {erpConnectorName && localStorage.getItem("Client_ID") && (
//                             <Button
//                                 variant="outlined"
//                                 onClick={handleErpConnectorButton}
//                                 sx={{
//                                     textTransform: 'none',
//                                     borderRadius: '12px',
//                                 }}
//                             >
//                                 {erpConnectorName}
//                             </Button>
//                         )}
//                         <Button
//                             variant="contained"
//                             startIcon={<Send size={18} />}
//                             onClick={handleSubmit}
//                             disabled={selected.length === 0}
//                             sx={{
//                                 textTransform: 'none',
//                                 borderRadius: '12px',
//                                 px: 3,
//                                 // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//                                 // '&:hover': {
//                                 //     background: 'linear-gradient(135deg, #5568d3 0%, #6a3f8f 100%)',
//                                 // }
//                             }}
//                         >
//                             Submit {selected.length > 0 && `(${selected.length})`}
//                         </Button>
//                     </Stack>
//                 </Box>

//                 <Collapse in={showFilters}>
//                     <Box sx={{
//                         p: 3,
//                         borderBottom: '1px solid #e0e0e0',
//                         background: '#f8f9fa',
//                     }}>
//                         <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 2 }}>
//                             Filter Data
//                         </Typography>
//                         <Box sx={{
//                             display: 'grid',
//                             gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
//                             gap: 2,
//                             mb: 3
//                         }}>
//                             <FormControl size="small" fullWidth>
//                                 <InputLabel>FS Type</InputLabel>
//                                 <Select
//                                     value={filters.fs_type}
//                                     label="FS Type"
//                                     onChange={(e) => handleFilterChange('fs_type', e.target.value)}
//                                 >
//                                     <MenuItem value="">All</MenuItem>
//                                     <MenuItem value="PL">PL</MenuItem>
//                                     <MenuItem value="BS">BS</MenuItem>
//                                 </Select>
//                             </FormControl>

//                             <FormControl size="small" fullWidth>
//                                 <InputLabel>P&L Type</InputLabel>
//                                 <Select
//                                     value={filters.p_and_l_type}
//                                     label="P&L Type"
//                                     onChange={(e) => handleFilterChange('p_and_l_type', e.target.value)}
//                                 >
//                                     <MenuItem value="">All</MenuItem>
//                                     {pAndLTypeOptions.map(opt => (
//                                         <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                                     ))}
//                                 </Select>
//                             </FormControl>

//                             <FormControl size="small" fullWidth>
//                                 <InputLabel>GST Applicable</InputLabel>
//                                 <Select
//                                     value={filters.gst_applicable}
//                                     label="GST Applicable"
//                                     onChange={(e) => handleFilterChange('gst_applicable', e.target.value)}
//                                 >
//                                     <MenuItem value="">All</MenuItem>
//                                     <MenuItem value="Yes">Yes</MenuItem>
//                                     <MenuItem value="No">No</MenuItem>
//                                 </Select>
//                             </FormControl>

//                             <FormControl size="small" fullWidth>
//                                 <InputLabel>TDS Applicable</InputLabel>
//                                 <Select
//                                     value={filters.tds_applicable}
//                                     label="TDS Applicable"
//                                     onChange={(e) => handleFilterChange('tds_applicable', e.target.value)}
//                                 >
//                                     <MenuItem value="">All</MenuItem>
//                                     <MenuItem value="Yes">Yes</MenuItem>
//                                     <MenuItem value="No">No</MenuItem>
//                                 </Select>
//                             </FormControl>
//                         </Box>

//                         <Divider sx={{ my: 2 }} />

//                         {/* Bulk Apply Section */}
//                         <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 2 }}>
//                             Bulk Apply to Filtered Rows ({filteredData.length} rows)
//                         </Typography>
//                         <Box sx={{
//                             display: 'grid',
//                             gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
//                             gap: 2
//                         }}>
//                             <Box sx={{ display: 'flex', gap: 1 }}>
//                                 <FormControl size="small" fullWidth>
//                                     <InputLabel>P&L Type</InputLabel>
//                                     <Select
//                                         value={bulkApply.p_and_l_type}
//                                         label="P&L Type"
//                                         onChange={(e) => setBulkApply(prev => ({ ...prev, p_and_l_type: e.target.value }))}
//                                     >
//                                         <MenuItem value="">Select</MenuItem>
//                                         {pAndLTypeOptions.map(opt => (
//                                             <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                                         ))}
//                                     </Select>
//                                 </FormControl>
//                                 <Button
//                                     variant="contained"
//                                     size="small"
//                                     onClick={() => handleBulkApply('p_and_l_type')}
//                                     disabled={!bulkApply.p_and_l_type}
//                                     sx={{ minWidth: 'auto', px: 2 }}
//                                 >
//                                     Apply
//                                 </Button>
//                             </Box>

//                             <Box sx={{ display: 'flex', gap: 1 }}>
//                                 <FormControl size="small" fullWidth>
//                                     <InputLabel>GST Applicable</InputLabel>
//                                     <Select
//                                         value={bulkApply.gst_applicable}
//                                         label="GST Applicable"
//                                         onChange={(e) => setBulkApply(prev => ({ ...prev, gst_applicable: e.target.value }))}
//                                     >
//                                         <MenuItem value="">Select</MenuItem>
//                                         {gstApplicableOptions.map(opt => (
//                                             <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                                         ))}
//                                     </Select>
//                                 </FormControl>
//                                 <Button
//                                     variant="contained"
//                                     size="small"
//                                     onClick={() => handleBulkApply('gst_applicable')}
//                                     disabled={!bulkApply.gst_applicable}
//                                     sx={{ minWidth: 'auto', px: 2 }}
//                                 >
//                                     Apply
//                                 </Button>
//                             </Box>

//                             <Box sx={{ display: 'flex', gap: 1 }}>
//                                 <FormControl size="small" fullWidth>
//                                     <InputLabel>TDS Applicable</InputLabel>
//                                     <Select
//                                         value={bulkApply.tds_applicable}
//                                         label="TDS Applicable"
//                                         onChange={(e) => setBulkApply(prev => ({ ...prev, tds_applicable: e.target.value }))}
//                                     >
//                                         <MenuItem value="">Select</MenuItem>
//                                         {tdsApplicableOptions.map(opt => (
//                                             <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                                         ))}
//                                     </Select>
//                                 </FormControl>
//                                 <Button
//                                     variant="contained"
//                                     size="small"
//                                     onClick={() => handleBulkApply('tds_applicable')}
//                                     disabled={!bulkApply.tds_applicable}
//                                     sx={{ minWidth: 'auto', px: 2 }}
//                                 >
//                                     Apply
//                                 </Button>
//                             </Box>

//                             <Box sx={{ display: 'flex', gap: 1 }}>
//                                 <FormControl size="small" fullWidth>
//                                     <InputLabel>TCS Applicable</InputLabel>
//                                     <Select
//                                         value={bulkApply.tcs_applicable}
//                                         label="TCS Applicable"
//                                         onChange={(e) => setBulkApply(prev => ({ ...prev, tcs_applicable: e.target.value }))}
//                                     >
//                                         <MenuItem value="">Select</MenuItem>
//                                         {tcsApplicableOptions.map(opt => (
//                                             <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                                         ))}
//                                     </Select>
//                                 </FormControl>
//                                 <Button
//                                     variant="contained"
//                                     size="small"
//                                     onClick={() => handleBulkApply('tcs_applicable')}
//                                     disabled={!bulkApply.tcs_applicable}
//                                     sx={{ minWidth: 'auto', px: 2 }}
//                                 >
//                                     Apply
//                                 </Button>
//                             </Box>

//                             <Box sx={{ display: 'flex', gap: 1 }}>
//                                 <FormControl size="small" fullWidth>
//                                     <InputLabel>GST Type Supply</InputLabel>
//                                     <Select
//                                         value={bulkApply.gst_type_of_supply}
//                                         label="GST Type Supply"
//                                         onChange={(e) => setBulkApply(prev => ({ ...prev, gst_type_of_supply: e.target.value }))}
//                                     >
//                                         <MenuItem value="">Select</MenuItem>
//                                         {gstTypeSupplyOptions.map(opt => (
//                                             <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                                         ))}
//                                     </Select>
//                                 </FormControl>
//                                 <Button
//                                     variant="contained"
//                                     size="small"
//                                     onClick={() => handleBulkApply('gst_type_of_supply')}
//                                     disabled={!bulkApply.gst_type_of_supply}
//                                     sx={{ minWidth: 'auto', px: 2 }}
//                                 >
//                                     Apply
//                                 </Button>
//                             </Box>

//                             <Box sx={{ display: 'flex', gap: 1 }}>
//                                 <FormControl size="small" fullWidth>
//                                     <InputLabel>GST Nature Supply</InputLabel>
//                                     <Select
//                                         value={bulkApply.gst_nature_of_supply}
//                                         label="GST Nature Supply"
//                                         onChange={(e) => setBulkApply(prev => ({ ...prev, gst_nature_of_supply: e.target.value }))}
//                                     >
//                                         <MenuItem value="">Select</MenuItem>
//                                         {gstNatureofSupplyOptions.map(opt => (
//                                             <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                                         ))}
//                                     </Select>
//                                 </FormControl>
//                                 <Button
//                                     variant="contained"
//                                     size="small"
//                                     onClick={() => handleBulkApply('gst_nature_of_supply')}
//                                     disabled={!bulkApply.gst_nature_of_supply}
//                                     sx={{ minWidth: 'auto', px: 2 }}
//                                 >
//                                     Apply
//                                 </Button>
//                             </Box>
//                         </Box>
//                     </Box>
//                 </Collapse>

//                 {/* Filters Panel */}
//                 {/* <Collapse in={showFilters}>
//                     <Box sx={{
//                         p: 3,
//                         borderBottom: '1px solid #e0e0e0',
//                         background: '#f8f9fa',
//                         display: 'grid',
//                         gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
//                         gap: 2
//                     }}>
//                         <FormControl size="small" fullWidth>
//                             <InputLabel>FS Type</InputLabel>
//                             <Select
//                                 value={filters.fs_type}
//                                 label="FS Type"
//                                 onChange={(e) => handleFilterChange('fs_type', e.target.value)}
//                             >
//                                 <MenuItem value="">All</MenuItem>
//                                 <MenuItem value="PL">PL</MenuItem>
//                                 <MenuItem value="BS">BS</MenuItem>
//                             </Select>
//                         </FormControl>

//                         <FormControl size="small" fullWidth>
//                             <InputLabel>P&L Type</InputLabel>
//                             <Select
//                                 value={filters.p_and_l_type}
//                                 label="P&L Type"
//                                 onChange={(e) => handleFilterChange('p_and_l_type', e.target.value)}
//                             >
//                                 <MenuItem value="">All</MenuItem>
//                                 {pAndLTypeOptions.map(opt => (
//                                     <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                                 ))}
//                             </Select>
//                         </FormControl>

//                         <FormControl size="small" fullWidth>
//                             <InputLabel>GST Applicable</InputLabel>
//                             <Select
//                                 value={filters.gst_applicable}
//                                 label="GST Applicable"
//                                 onChange={(e) => handleFilterChange('gst_applicable', e.target.value)}
//                             >
//                                 <MenuItem value="">All</MenuItem>
//                                 <MenuItem value="Yes">Yes</MenuItem>
//                                 <MenuItem value="No">No</MenuItem>
//                             </Select>
//                         </FormControl>

//                         <FormControl size="small" fullWidth>
//                             <InputLabel>TDS Applicable</InputLabel>
//                             <Select
//                                 value={filters.tds_applicable}
//                                 label="TDS Applicable"
//                                 onChange={(e) => handleFilterChange('tds_applicable', e.target.value)}
//                             >
//                                 <MenuItem value="">All</MenuItem>
//                                 <MenuItem value="Yes">Yes</MenuItem>
//                                 <MenuItem value="No">No</MenuItem>
//                             </Select>
//                         </FormControl>
//                     </Box>
//                 </Collapse> */}

//                 {/* Table */}
//                 <TableContainer sx={{ maxHeight: 600 }}>
//                     <Table stickyHeader>
//                         <TableHead>
//                             <TableRow>
//                                 <TableCell padding="checkbox" sx={{ background: '#f8f9fa', fontWeight: 700 }}>
//                                     <Checkbox
//                                         indeterminate={selected.length > 0 && selected.length < filteredData.length}
//                                         checked={filteredData.length > 0 && selected.length === filteredData.length}
//                                         onChange={handleSelectAllClick}
//                                     />
//                                 </TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 100 }}>Type</TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 150 }}>Ledger Group 1</TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 150 }}>Ledger Group 2</TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 150 }}>Ledger Group 3</TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 150 }}>Ledger Group 4</TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 150 }}>Ledger ID</TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 150 }}>Ledger Code</TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 200 }}>P&L Type</TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 200 }}>Ledger Name</TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 150 }}>GST Applicable</TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 150 }}>TDS Applicable</TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 150 }}>TCS Applicable</TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 180 }}>GST Type Supply</TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 180 }}>GST Nature Supply</TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 150 }}>TDS Section Number</TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 150 }}>TCS Section Number</TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 120 }}>HSN Code</TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 120 }}>IGST Rate</TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 120 }}>CGST Rate</TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 120 }}>SGST Rate</TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 120 }}>CESS Rate</TableCell>
//                                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 150 }}>Opening Balance</TableCell>
//                             </TableRow>
//                         </TableHead>
//                         <TableBody>
//                             {loaderForTable ? (
//                                 <TableRow>
//                                     <TableCell colSpan={23} align="center" sx={{ py: 10 }}>
//                                         <Typography>Loading...</Typography>
//                                     </TableCell>
//                                 </TableRow>
//                             ) : filteredData.length === 0 ? (
//                                 <TableRow>
//                                     <TableCell colSpan={23} align="center" sx={{ py: 10 }}>
//                                         <Typography>No data available</Typography>
//                                     </TableCell>
//                                 </TableRow>
//                             ) : (
//                                 filteredData
//                                     .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                                     .map((row) => {
//                                         const isItemSelected = selected.includes(row.id);
//                                         return (
//                                             <TableRow
//                                                 key={row.id}
//                                                 hover
//                                                 onClick={(event) => handleClick(event, row.id)}
//                                                 selected={isItemSelected}
//                                                 sx={{
//                                                     cursor: 'pointer',
//                                                     transition: 'all 0.2s',
//                                                     '&:hover': {
//                                                         background: 'linear-gradient(90deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)',
//                                                         transform: 'scale(1.002)',
//                                                     },
//                                                     '&.Mui-selected': {
//                                                         background: 'linear-gradient(90deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
//                                                         '&:hover': {
//                                                             background: 'linear-gradient(90deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%)',
//                                                         }
//                                                     }
//                                                 }}
//                                             >
//                                                 <TableCell padding="checkbox">
//                                                     <Checkbox checked={isItemSelected} onClick={e => e.stopPropagation()} />
//                                                 </TableCell>
//                                                 <TableCell>
//                                                     <Chip
//                                                         label={row.fs_type}
//                                                         size="small"
//                                                         sx={{
//                                                             background: row.fs_type === 'PL'
//                                                                 ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
//                                                                 : 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
//                                                             color: 'white',
//                                                             fontWeight: 600
//                                                         }}
//                                                     />
//                                                 </TableCell>
//                                                 <TableCell>{row.ledger_group_1}</TableCell>
//                                                 <TableCell>{row.ledger_group_2}</TableCell>
//                                                 <TableCell>{row.ledger_group_3}</TableCell>
//                                                 <TableCell>{row.ledger_group_4}</TableCell>
//                                                 <TableCell>{row.ledger_id}</TableCell>
//                                                 <TableCell>{row.ledger_code}</TableCell>
//                                                 <TableCell onClick={e => e.stopPropagation()}>
//                                                     {row.fs_type === "BS" ? (
//                                                         <Typography variant="body2" color="text.secondary">-</Typography>
//                                                     ) : (
//                                                         <FormControl size="small" fullWidth>
//                                                             <Select
//                                                                 value={recordStatuses[row.id]?.p_and_l_type || ""}
//                                                                 onChange={(e) => handleStatusChange(row.id, "p_and_l_type", e.target.value)}
//                                                             >
//                                                                 <MenuItem value="" disabled>Select</MenuItem>
//                                                                 {pAndLTypeOptions.map((opt) => (
//                                                                     <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                                                                 ))}
//                                                             </Select>
//                                                         </FormControl>
//                                                     )}
//                                                 </TableCell>
//                                                 <TableCell sx={{ fontWeight: 600 }}>{row.ledger_name}</TableCell>
//                                                 <TableCell onClick={e => e.stopPropagation()}>
//                                                     <FormControl size="small" fullWidth>
//                                                         <Select
//                                                             value={recordStatuses[row.id]?.gst_applicable || ""}
//                                                             onChange={(e) => handleStatusChange(row.id, "gst_applicable", e.target.value)}
//                                                         >
//                                                             <MenuItem value="" disabled>Select</MenuItem>
//                                                             {gstApplicableOptions.map(opt => (
//                                                                 <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                                                             ))}
//                                                         </Select>
//                                                     </FormControl>
//                                                 </TableCell>
//                                                 <TableCell onClick={e => e.stopPropagation()}>
//                                                     <FormControl size="small" fullWidth>
//                                                         <Select
//                                                             value={recordStatuses[row.id]?.tds_applicable || ""}
//                                                             onChange={(e) => handleStatusChange(row.id, "tds_applicable", e.target.value)}
//                                                         >
//                                                             <MenuItem value="" disabled>Select</MenuItem>
//                                                             {tdsApplicableOptions.map(opt => (
//                                                                 <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                                                             ))}
//                                                         </Select>
//                                                     </FormControl>
//                                                 </TableCell>
//                                                 <TableCell onClick={e => e.stopPropagation()}>
//                                                     <FormControl size="small" fullWidth>
//                                                         <Select
//                                                             value={recordStatuses[row.id]?.tcs_applicable || ""}
//                                                             onChange={(e) => handleStatusChange(row.id, "tcs_applicable", e.target.value)}
//                                                         >
//                                                             <MenuItem value="" disabled>Select</MenuItem>
//                                                             {tcsApplicableOptions.map(opt => (
//                                                                 <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                                                             ))}
//                                                         </Select>
//                                                     </FormControl>
//                                                 </TableCell>
//                                                 <TableCell onClick={e => e.stopPropagation()}>
//                                                     <FormControl size="small" fullWidth>
//                                                         <Select
//                                                             value={recordStatuses[row.id]?.gst_type_of_supply || ""}
//                                                             onChange={(e) => handleStatusChange(row.id, "gst_type_of_supply", e.target.value)}
//                                                         >
//                                                             <MenuItem value="" disabled>Select</MenuItem>
//                                                             {gstTypeSupplyOptions.map(opt => (
//                                                                 <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                                                             ))}
//                                                         </Select>
//                                                     </FormControl>
//                                                 </TableCell>
//                                                 <TableCell onClick={e => e.stopPropagation()}>
//                                                     <FormControl size="small" fullWidth>
//                                                         <Select
//                                                             value={recordStatuses[row.id]?.gst_nature_of_supply || ""}
//                                                             onChange={(e) => handleStatusChange(row.id, "gst_nature_of_supply", e.target.value)}
//                                                         >
//                                                             <MenuItem value="" disabled>Select</MenuItem>
//                                                             {gstNatureofSupplyOptions.map(opt => (
//                                                                 <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                                                             ))}
//                                                         </Select>
//                                                     </FormControl>
//                                                 </TableCell>
//                                                 <TableCell>{row.tds_section_number}</TableCell>
//                                                 <TableCell>{row.tcs_section_number}</TableCell>
//                                                 <TableCell>{row.hsn_code}</TableCell>
//                                                 <TableCell>{row.igst_rate}</TableCell>
//                                                 <TableCell>{row.cgst_rate}</TableCell>
//                                                 <TableCell>{row.sgst_rate}</TableCell>
//                                                 <TableCell>{row.cess_rate}</TableCell>
//                                                 <TableCell>{row.opening_balance}</TableCell>
//                                             </TableRow>
//                                         );
//                                     })
//                             )}
//                         </TableBody>
//                     </Table>
//                 </TableContainer>

//                 {/* Pagination */}
//                 <TablePagination
//                     rowsPerPageOptions={[5, 10, 25, 50]}
//                     component="div"
//                     count={filteredData.length}
//                     rowsPerPage={rowsPerPage}
//                     page={page}
//                     onPageChange={handleChangePage}
//                     onRowsPerPageChange={handleChangeRowsPerPage}
//                     sx={{
//                         borderTop: '1px solid #e0e0e0',
//                         background: '#f8f9fa'
//                     }}
//                 />
//             </Paper>

//             {/* Snackbar */}
//             <Snackbar
//                 open={snackbar.open}
//                 autoHideDuration={4000}
//                 onClose={() => setSnackbar({ ...snackbar, open: false })}
//                 anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
//             >
//                 <Alert
//                     onClose={() => setSnackbar({ ...snackbar, open: false })}
//                     severity={snackbar.severity}
//                     sx={{
//                         borderRadius: '12px',
//                         boxShadow: '0 8px 32px rgba(0,0,0,0.2)'
//                     }}
//                 >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Box>
//     );
// };

// const COAReport = ({
//   recordForTable,
//   loaderForTable,
//   getApiImsReport,
//   gridApiRef,
//   erpConnectorName,
//   setZohoTriggerForDebit
// }) => {
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "info",
//   });

//   const [recordStatuses, setRecordStatuses] = useState({});
//   const [selected, setSelected] = useState([]);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   // Filter states
//   const [filters, setFilters] = useState({
//     searchTerm: '',
//     fs_type: '',
//     gst_applicable: '',
//     tds_applicable: '',
//     p_and_l_type: ''
//   });

//   const [showFilters, setShowFilters] = useState(false);

//   useEffect(() => {
//     const statuses = recordForTable.reduce((acc, row) => {
//       acc[row.id] = {
//         p_and_l_type: row.p_and_l_type || "",
//         gst_applicable: row.gst_applicable || "",
//         tds_applicable: row.tds_applicable || "",
//         tcs_applicable: row.tcs_applicable || "",
//         gst_type_of_supply: row.gst_type_of_supply || "",
//         gst_nature_of_supply: row.gst_nature_of_supply || "",
//       };
//       return acc;
//     }, {});
//     setRecordStatuses(statuses);
//     setSelected([]);
//   }, [recordForTable]);

//   const handleStatusChange = (id, field, value) => {
//     setRecordStatuses(prev => ({
//       ...prev,
//       [id]: { ...prev[id], [field]: value }
//     }));
//     if (!selected.includes(id)) {
//       setSelected(prev => [...prev, id]);
//     }
//   };

//   const handleSelectAllClick = (event) => {
//     if (event.target.checked) {
//       const newSelected = filteredData.map((n) => n.id);
//       setSelected(newSelected);
//       return;
//     }
//     setSelected([]);
//   };

//   const handleClick = (event, id) => {
//     const selectedIndex = selected.indexOf(id);
//     let newSelected = [];

//     if (selectedIndex === -1) {
//       newSelected = newSelected.concat(selected, id);
//     } else if (selectedIndex === 0) {
//       newSelected = newSelected.concat(selected.slice(1));
//     } else if (selectedIndex === selected.length - 1) {
//       newSelected = newSelected.concat(selected.slice(0, -1));
//     } else if (selectedIndex > 0) {
//       newSelected = newSelected.concat(
//         selected.slice(0, selectedIndex),
//         selected.slice(selectedIndex + 1),
//       );
//     }

//     setSelected(newSelected);
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const handleFilterChange = (field, value) => {
//     setFilters(prev => ({ ...prev, [field]: value }));
//     setPage(0);
//   };

//   const clearFilters = () => {
//     setFilters({
//       searchTerm: '',
//       fs_type: '',
//       gst_applicable: '',
//       tds_applicable: '',
//       p_and_l_type: ''
//     });
//   };

//   const handleSubmit = async () => {
//     if (selected.length === 0) {
//       setSnackbar({
//         open: true,
//         message: "Please select at least one record to submit.",
//         severity: "warning",
//       });
//       return;
//     }

//     const selectedData = selected.map(id => {
//       const row = recordForTable.find(r => r.id === id);
//       return {
//         ...row,
//         ...recordStatuses[id]
//       };
//     });

//     const payload = {
//       business_entity_id: localStorage.getItem("business_entity_id"),
//       records: selectedData.map(row => ({
//         id: row.id,
//         entity_gstn: row.entity_gstn,
//         branch_name: row.branch_name,
//         category: row.category,
//         cwn_coa_id: row.cwn_coa_id,
//         fs_type: row.fs_type,
//         ledger_group_1: row.ledger_group_1,
//         ledger_group_2: row.ledger_group_2,
//         ledger_group_3: row.ledger_group_3,
//         ledger_group_4: row.ledger_group_4,
//         ledger_id: row.ledger_id,
//         ledger_code: row.ledger_code,
//         p_and_l_type: recordStatuses[row.id]?.p_and_l_type || row.p_and_l_type || null,
//         ledger_name: row.ledger_name,
//         gst_applicable: recordStatuses[row.id]?.gst_applicable || row.gst_applicable || null,
//         tds_applicable: recordStatuses[row.id]?.tds_applicable || row.tds_applicable || null,
//         tcs_applicable: recordStatuses[row.id]?.tcs_applicable || row.tcs_applicable || null,
//         gst_type_of_supply: recordStatuses[row.id]?.gst_type_of_supply || row.gst_type_of_supply || null,
//         gst_nature_of_supply: recordStatuses[row.id]?.gst_nature_of_supply || row.gst_nature_of_supply || null,
//         tds_section_number: row.tds_section_number,
//         tcs_section_number: row.tcs_section_number,
//         hsn_code: row.hsn_code,
//         igst_rate: row.igst_rate,
//         cgst_rate: row.cgst_rate,
//         sgst_rate: row.sgst_rate,
//         cess_rate: row.cess_rate,
//         opening_balance: row.opening_balance,
//         status: row.status,
//       })),
//     };

//     try {
//       const res = await axios.post("/arc/update/coa", payload);
//       setSnackbar({
//         open: true,
//         message: "Selected records submitted successfully",
//         severity: "success",
//       });
//       if (getApiImsReport) await getApiImsReport();
//       setSelected([]);
//     } catch (error) {
//       setSnackbar({
//         open: true,
//         message: error.response?.data?.message || "Error submitting records",
//         severity: "error",
//       });
//     }
//   };

//   const handleErpConnectorButton = () => {
//     setZohoTriggerForDebit({
//       messageForConnection: "Establish Connection",
//       buttonColor: "red",
//       zohoShowButton: true,
//     });
//   };

//   // Filtered data logic
//   const filteredData = recordForTable.filter(row => {
//     const matchesSearch = !filters.searchTerm ||
//       Object.values(row).some(val =>
//         String(val).toLowerCase().includes(filters.searchTerm.toLowerCase())
//       );

//     const matchesFsType = !filters.fs_type || row.fs_type === filters.fs_type;
//     const matchesGst = !filters.gst_applicable || row.gst_applicable === filters.gst_applicable;
//     const matchesTds = !filters.tds_applicable || row.tds_applicable === filters.tds_applicable;
//     const matchesPnL = !filters.p_and_l_type || row.p_and_l_type === filters.p_and_l_type;

//     return matchesSearch && matchesFsType && matchesGst && matchesTds && matchesPnL;
//   });

//   const activeFiltersCount = Object.values(filters).filter(v => v !== '').length;

//   return (
//     <Box sx={{
//       width: '100%',
//       p: 3,
//     //   background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//       minHeight: '100vh'
//     }}>
//       <Paper
//         elevation={24}
//         sx={{
//           borderRadius: '24px',
//           overflow: 'hidden',
//           background: 'rgba(255, 255, 255, 0.95)',
//           backdropFilter: 'blur(20px)',
//           boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
//         }}
//       >
//         {/* Header */}
//         <Box sx={{
//           background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//           p: 3,
//           color: 'white'
//         }}>
//           <Typography variant="h4" fontWeight="700" sx={{ mb: 1 }}>
//             Chart of Accounts
//           </Typography>
//           <Typography variant="body2" sx={{ opacity: 0.9 }}>
//             Manage and configure your ledger accounts
//           </Typography>
//         </Box>

//         {/* Toolbar */}
//         <Box sx={{
//           p: 2,
//           borderBottom: '1px solid #e0e0e0',
//           display: 'flex',
//           gap: 2,
//           flexWrap: 'wrap',
//           alignItems: 'center',
//           justifyContent: 'space-between'
//         }}>
//           <Stack direction="row" spacing={2} sx={{ flex: 1 }}>
//             <TextField
//               size="small"
//               placeholder="Search across all columns..."
//               value={filters.searchTerm}
//               onChange={(e) => handleFilterChange('searchTerm', e.target.value)}
//               sx={{ minWidth: 300 }}
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <Search size={20} />
//                   </InputAdornment>
//                 ),
//               }}
//             />

//             <Button
//               variant={showFilters ? "contained" : "outlined"}
//               startIcon={<Filter size={18} />}
//               onClick={() => setShowFilters(!showFilters)}
//               sx={{
//                 textTransform: 'none',
//                 borderRadius: '12px',
//               }}
//             >
//               Filters
//               {activeFiltersCount > 0 && (
//                 <Chip
//                   label={activeFiltersCount}
//                   size="small"
//                   sx={{
//                     ml: 1,
//                     height: 20,
//                     fontSize: '0.75rem',
//                     background: 'rgba(255,255,255,0.3)'
//                   }}
//                 />
//               )}
//             </Button>

//             {activeFiltersCount > 0 && (
//               <Button
//                 size="small"
//                 startIcon={<X size={16} />}
//                 onClick={clearFilters}
//                 sx={{ textTransform: 'none' }}
//               >
//                 Clear
//               </Button>
//             )}
//           </Stack>

//           <Button
//             variant="contained"
//             startIcon={<Send size={18} />}
//             onClick={handleSubmit}
//             disabled={selected.length === 0}
//             sx={{
//               textTransform: 'none',
//               borderRadius: '12px',
//               px: 3,
//               background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//               '&:hover': {
//                 background: 'linear-gradient(135deg, #5568d3 0%, #6a3f8f 100%)',
//               }
//             }}
//           >
//             Submit {selected.length > 0 && `(${selected.length})`}
//           </Button>
//         </Box>

//         {/* Filters Panel */}
//         <Collapse in={showFilters}>
//           <Box sx={{
//             p: 3,
//             borderBottom: '1px solid #e0e0e0',
//             background: '#f8f9fa',
//             display: 'grid',
//             gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
//             gap: 2
//           }}>
//             <FormControl size="small" fullWidth>
//               <InputLabel>FS Type</InputLabel>
//               <Select
//                 value={filters.fs_type}
//                 label="FS Type"
//                 onChange={(e) => handleFilterChange('fs_type', e.target.value)}
//               >
//                 <MenuItem value="">All</MenuItem>
//                 <MenuItem value="PL">PL</MenuItem>
//                 <MenuItem value="BS">BS</MenuItem>
//               </Select>
//             </FormControl>

//             <FormControl size="small" fullWidth>
//               <InputLabel>P&L Type</InputLabel>
//               <Select
//                 value={filters.p_and_l_type}
//                 label="P&L Type"
//                 onChange={(e) => handleFilterChange('p_and_l_type', e.target.value)}
//               >
//                 <MenuItem value="">All</MenuItem>
//                 {pAndLTypeOptions.map(opt => (
//                   <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             <FormControl size="small" fullWidth>
//               <InputLabel>GST Applicable</InputLabel>
//               <Select
//                 value={filters.gst_applicable}
//                 label="GST Applicable"
//                 onChange={(e) => handleFilterChange('gst_applicable', e.target.value)}
//               >
//                 <MenuItem value="">All</MenuItem>
//                 <MenuItem value="Yes">Yes</MenuItem>
//                 <MenuItem value="No">No</MenuItem>
//               </Select>
//             </FormControl>

//             <FormControl size="small" fullWidth>
//               <InputLabel>TDS Applicable</InputLabel>
//               <Select
//                 value={filters.tds_applicable}
//                 label="TDS Applicable"
//                 onChange={(e) => handleFilterChange('tds_applicable', e.target.value)}
//               >
//                 <MenuItem value="">All</MenuItem>
//                 <MenuItem value="Yes">Yes</MenuItem>
//                 <MenuItem value="No">No</MenuItem>
//               </Select>
//             </FormControl>
//           </Box>
//         </Collapse>

//         {/* Table */}
//         <TableContainer sx={{ maxHeight: 600 }}>
//           <Table stickyHeader>
//             <TableHead>
//               <TableRow>
//                 <TableCell padding="checkbox" sx={{ background: '#f8f9fa', fontWeight: 700 }}>
//                   <Checkbox
//                     indeterminate={selected.length > 0 && selected.length < filteredData.length}
//                     checked={filteredData.length > 0 && selected.length === filteredData.length}
//                     onChange={handleSelectAllClick}
//                   />
//                 </TableCell>
//                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 100 }}>Type</TableCell>
//                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 150 }}>Ledger ID</TableCell>
//                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 150 }}>Ledger Code</TableCell>
//                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 220 }}>Ledger Name</TableCell>
//                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 150 }}>P&L Type</TableCell>
//                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 150 }}>GST Applicable</TableCell>
//                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 150 }}>TDS Applicable</TableCell>
//                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 150 }}>TCS Applicable</TableCell>
//                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 180 }}>GST Type Supply</TableCell>
//                 <TableCell sx={{ background: '#f8f9fa', fontWeight: 700, minWidth: 180 }}>GST Nature Supply</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {filteredData
//                 .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                 .map((row) => {
//                   const isItemSelected = selected.includes(row.id);
//                   return (
//                     <TableRow
//                       key={row.id}
//                       hover
//                       onClick={(event) => handleClick(event, row.id)}
//                       selected={isItemSelected}
//                       sx={{
//                         cursor: 'pointer',
//                         transition: 'all 0.2s',
//                         '&:hover': {
//                           background: 'linear-gradient(90deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)',
//                           transform: 'scale(1.002)',
//                         },
//                         '&.Mui-selected': {
//                           background: 'linear-gradient(90deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)',
//                           '&:hover': {
//                             background: 'linear-gradient(90deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%)',
//                           }
//                         }
//                       }}
//                     >
//                       <TableCell padding="checkbox">
//                         <Checkbox checked={isItemSelected} onClick={e => e.stopPropagation()} />
//                       </TableCell>
//                       <TableCell>
//                         <Chip
//                           label={row.fs_type}
//                           size="small"
//                           sx={{
//                             background: row.fs_type === 'PL'
//                               ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
//                               : 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
//                             color: 'white',
//                             fontWeight: 600
//                           }}
//                         />
//                       </TableCell>
//                       <TableCell>{row.ledger_id}</TableCell>
//                       <TableCell>{row.ledger_code}</TableCell>
//                       <TableCell sx={{ fontWeight: 600 }}>{row.ledger_name}</TableCell>

//                       <TableCell onClick={e => e.stopPropagation()}>
//                         {row.fs_type === "BS" ? (
//                           <Typography variant="body2" color="text.secondary">-</Typography>
//                         ) : (
//                           <FormControl size="small" fullWidth>
//                             <Select
//                               value={recordStatuses[row.id]?.p_and_l_type || ""}
//                               onChange={(e) => handleStatusChange(row.id, "p_and_l_type", e.target.value)}
//                             >
//                               <MenuItem value="" disabled>Select</MenuItem>
//                               {pAndLTypeOptions.map((opt) => (
//                                 <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                               ))}
//                             </Select>
//                           </FormControl>
//                         )}
//                       </TableCell>

//                       <TableCell onClick={e => e.stopPropagation()}>
//                         <FormControl size="small" fullWidth>
//                           <Select
//                             value={recordStatuses[row.id]?.gst_applicable || ""}
//                             onChange={(e) => handleStatusChange(row.id, "gst_applicable", e.target.value)}
//                           >
//                             <MenuItem value="" disabled>Select</MenuItem>
//                             {gstApplicableOptions.map(opt => (
//                               <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                             ))}
//                           </Select>
//                         </FormControl>
//                       </TableCell>

//                       <TableCell onClick={e => e.stopPropagation()}>
//                         <FormControl size="small" fullWidth>
//                           <Select
//                             value={recordStatuses[row.id]?.tds_applicable || ""}
//                             onChange={(e) => handleStatusChange(row.id, "tds_applicable", e.target.value)}
//                           >
//                             <MenuItem value="" disabled>Select</MenuItem>
//                             {tdsApplicableOptions.map(opt => (
//                               <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                             ))}
//                           </Select>
//                         </FormControl>
//                       </TableCell>

//                       <TableCell onClick={e => e.stopPropagation()}>
//                         <FormControl size="small" fullWidth>
//                           <Select
//                             value={recordStatuses[row.id]?.tcs_applicable || ""}
//                             onChange={(e) => handleStatusChange(row.id, "tcs_applicable", e.target.value)}
//                           >
//                             <MenuItem value="" disabled>Select</MenuItem>
//                             {tcsApplicableOptions.map(opt => (
//                               <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                             ))}
//                           </Select>
//                         </FormControl>
//                       </TableCell>

//                       <TableCell onClick={e => e.stopPropagation()}>
//                         <FormControl size="small" fullWidth>
//                           <Select
//                             value={recordStatuses[row.id]?.gst_type_of_supply || ""}
//                             onChange={(e) => handleStatusChange(row.id, "gst_type_of_supply", e.target.value)}
//                           >
//                             <MenuItem value="" disabled>Select</MenuItem>
//                             {gstTypeSupplyOptions.map(opt => (
//                               <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                             ))}
//                           </Select>
//                         </FormControl>
//                       </TableCell>

//                       <TableCell onClick={e => e.stopPropagation()}>
//                         <FormControl size="small" fullWidth>
//                           <Select
//                             value={recordStatuses[row.id]?.gst_nature_of_supply || ""}
//                             onChange={(e) => handleStatusChange(row.id, "gst_nature_of_supply", e.target.value)}
//                           >
//                             <MenuItem value="" disabled>Select</MenuItem>
//                             {gstNatureofSupplyOptions.map(opt => (
//                               <MenuItem key={opt} value={opt}>{opt}</MenuItem>
//                             ))}
//                           </Select>
//                         </FormControl>
//                       </TableCell>
//                     </TableRow>
//                   );
//                 })}
//             </TableBody>
//           </Table>
//         </TableContainer>

//         {/* Pagination */}
//         <TablePagination
//           rowsPerPageOptions={[5, 10, 25, 50]}
//           component="div"
//           count={filteredData.length}
//           rowsPerPage={rowsPerPage}
//           page={page}
//           onPageChange={handleChangePage}
//           onRowsPerPageChange={handleChangeRowsPerPage}
//           sx={{
//             borderTop: '1px solid #e0e0e0',
//             background: '#f8f9fa'
//           }}
//         />
//       </Paper>

//       {/* Snackbar */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={4000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//         anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
//       >
//         <Alert
//           onClose={() => setSnackbar({ ...snackbar, open: false })}
//           severity={snackbar.severity}
//           sx={{
//             borderRadius: '12px',
//             boxShadow: '0 8px 32px rgba(0,0,0,0.2)'
//           }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// const COAReport = ({
//     recordForTable,
//     loaderForTable,
//     getApiImsReport,
//     gridApiRef,
//     erpConnectorName,
//     setZohoTriggerForDebit
// }) => {
//     const [snackbar, setSnackbar] = useState({
//         open: false,
//         message: "",
//         severity: "info",
//     });
//     const [recordStatuses, setRecordStatuses] = useState(
//         recordForTable.reduce((acc, row) => {
//             acc[row.id] = {
//                 status: row.status || "",
//                 p_and_l_type: row.p_and_l_type || "",
//                 gst_applicable: row.gst_applicable || "",
//                 tds_applicable: row.tds_applicable || "",
//                 tcs_applicable: row.tcs_applicable || "",
//                 gst_type_of_supply: row.gst_type_of_supply || "",
//                 gst_nature_of_supply: row.gst_nature_of_supply || "",
//             };
//             return acc;
//         }, {})
//     );
//     const [selectedRows, setSelectedRows] = useState([]);

//     useEffect(() => {
//         setRecordStatuses(
//             recordForTable.reduce((acc, row) => {
//                 acc[row.id] = {
//                     status: row.status || "",
//                     p_and_l_type: row.p_and_l_type || "",
//                     gst_applicable: row.gst_applicable || "",
//                     tds_applicable: row.tds_applicable || "",
//                     tcs_applicable: row.tcs_applicable || "",
//                     gst_type_of_supply: row.gst_type_of_supply || "",
//                     gst_nature_of_supply: row.gst_nature_of_supply || "",
//                 };
//                 return acc;
//             }, {})
//         );
//         setSelectedRows([]);
//     }, [recordForTable]);

//     const handleStatusChange = (id, field, newValue) => {
//         setRecordStatuses((prev) => ({
//             ...prev,
//             [id]: { ...prev[id], [field]: newValue },
//         }));
//         if (!selectedRows.includes(id)) {
//             setSelectedRows((prev) => [...prev, id]);
//         }
//     };

//     const handleSubmit = async () => {
//         const selectedRowsData = selectedRows
//             .map((id) => recordForTable.find((row) => row.id === id))
//             .filter(Boolean);

//         console.log("Selected Rows:", selectedRowsData);
//         console.log("Record Statuses:", recordStatuses);

//         if (selectedRowsData.length === 0) {
//             setSnackbar({
//                 open: true,
//                 message: "Please select at least one record to submit.",
//                 severity: "warning",
//             });
//             return;
//         }

//         const payload = {
//             business_entity_id: localStorage.getItem("business_entity_id"),
//             records: selectedRowsData.map((row) => ({
//                 id: row.id,
//                 entity_gstn: row.entity_gstn,
//                 branch_name: row.branch_name,
//                 category: row.category,
//                 cwn_coa_id: row.cwn_coa_id,
//                 fs_type: row.fs_type,
//                 ledger_group_1: row.ledger_group_1,
//                 ledger_group_2: row.ledger_group_2,
//                 ledger_group_3: row.ledger_group_3,
//                 ledger_group_4: row.ledger_group_4,
//                 ledger_id: row.ledger_id,
//                 ledger_code: row.ledger_code,
//                 p_and_l_type: recordStatuses[row.id]?.p_and_l_type || row.p_and_l_type || null,
//                 ledger_name: row.ledger_name,
//                 gst_applicable: recordStatuses[row.id]?.gst_applicable || row.gst_applicable || null,
//                 tds_applicable: recordStatuses[row.id]?.tds_applicable || row.tds_applicable || null,
//                 tcs_applicable: recordStatuses[row.id]?.tcs_applicable || row.tcs_applicable || null,
//                 gst_type_of_supply: recordStatuses[row.id]?.gst_type_of_supply || row.gst_type_of_supply || null,
//                 gst_nature_of_supply: recordStatuses[row.id]?.gst_nature_of_supply || row.gst_nature_of_supply || null,
//                 tds_section_number: row.tds_section_number,
//                 tcs_section_number: row.tcs_section_number,
//                 hsn_code: row.hsn_code,
//                 igst_rate: row.igst_rate,
//                 cgst_rate: row.cgst_rate,
//                 sgst_rate: row.sgst_rate,
//                 cess_rate: row.cess_rate,
//                 opening_balance: row.opening_balance,
//                 status: row.status,
//             })),
//         };

//         console.log("Payload:", JSON.stringify(payload, null, 2));

//         try {
//             const res = await axios.post("/arc/update/coa", payload);
//             setSnackbar({
//                 open: true,
//                 message: "Selected records submitted successfully",
//                 severity: "success",
//             });
//             if (getApiImsReport) {
//                 await getApiImsReport();
//             }
//             setSelectedRows([]);
//         } catch (error) {
//             setSnackbar({
//                 open: true,
//                 message: error.response?.data?.message || "Error submitting selected records",
//                 severity: "error",
//             });
//         }
//     };

//     const handleErpConnectorButton = () => {
//         console.log("true");
//         setZohoTriggerForDebit({
//             messageForConnection: "Establish Connection",
//             buttonColor: "red",
//             zohoShowButton: true,
//         });
//     };

//     return (
//         <>
//             <Box sx={{ 
//                 height: "65vh", 
//                 width: "100%", 
//                 marginTop: "4px",
//                 padding: "20px",
//                 background: "linear-gradient(to bottom, #0a0e27 0%, #1a1f3a 100%)",
//                 borderRadius: "20px",
//                 position: "relative",
//                 overflow: "hidden",
//                 "&::before": {
//                     content: '""',
//                     position: "absolute",
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     height: "2px",
//                     background: "linear-gradient(90deg, #00d4ff 0%, #7b2ff7 50%, #f107e4 100%)",
//                     animation: "shimmer 3s ease-in-out infinite",
//                 },
//                 "@keyframes shimmer": {
//                     "0%, 100%": { opacity: 1 },
//                     "50%": { opacity: 0.5 },
//                 },
//                 // Global styles for popovers and menus
//                 "& .MuiPopover-paper": {
//                     backgroundColor: "rgba(255, 255, 255, 0.98) !important",
//                     backdropFilter: "blur(20px)",
//                     border: "1px solid rgba(59, 130, 246, 0.4)",
//                     boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3), 0 0 20px rgba(59, 130, 246, 0.3)",
//                     borderRadius: "12px",
//                     color: "#1e293b",
//                 },
//                 "& .MuiMenu-paper": {
//                     backgroundColor: "rgba(255, 255, 255, 0.98) !important",
//                     backdropFilter: "blur(20px)",
//                     border: "1px solid rgba(59, 130, 246, 0.4)",
//                     boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3), 0 0 20px rgba(59, 130, 246, 0.3)",
//                     borderRadius: "12px",
//                 },
//                 "& .MuiMenuItem-root": {
//                     color: "#1e293b",
//                     fontSize: "0.875rem",
//                     padding: "10px 16px",
//                     transition: "all 0.2s ease",
//                     "&:hover": {
//                         backgroundColor: "rgba(59, 130, 246, 0.15)",
//                         color: "#3b82f6",
//                         transform: "translateX(4px)",
//                     },
//                     "&.Mui-selected": {
//                         backgroundColor: "rgba(59, 130, 246, 0.2)",
//                         color: "#3b82f6",
//                         fontWeight: 600,
//                         "&:hover": {
//                             backgroundColor: "rgba(59, 130, 246, 0.25)",
//                         },
//                     },
//                 },
//                 "& .MuiInputBase-root": {
//                     color: "#1e293b",
//                     backgroundColor: "rgba(255, 255, 255, 0.95)",
//                     borderRadius: "8px",
//                     border: "1px solid rgba(59, 130, 246, 0.3)",
//                 },
//                 "& .MuiInputLabel-root": {
//                     color: "#64748b",
//                     fontWeight: 500,
//                     "&.Mui-focused": {
//                         color: "#3b82f6",
//                         fontWeight: 600,
//                     },
//                 },
//                 "& .MuiOutlinedInput-notchedOutline": {
//                     borderColor: "rgba(59, 130, 246, 0.4)",
//                 },
//                 "& .MuiOutlinedInput-root": {
//                     "&:hover .MuiOutlinedInput-notchedOutline": {
//                         borderColor: "rgba(59, 130, 246, 0.6)",
//                     },
//                     "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//                         borderColor: "#3b82f6",
//                         borderWidth: "2px",
//                         boxShadow: "0 0 15px rgba(59, 130, 246, 0.4)",
//                     },
//                 },
//                 "& .MuiButton-root": {
//                     color: "#3b82f6",
//                     borderColor: "rgba(59, 130, 246, 0.4)",
//                     textTransform: "none",
//                     fontWeight: 600,
//                     backgroundColor: "rgba(59, 130, 246, 0.05)",
//                     "&:hover": {
//                         backgroundColor: "rgba(59, 130, 246, 0.15)",
//                         borderColor: "#3b82f6",
//                         boxShadow: "0 0 20px rgba(59, 130, 246, 0.4)",
//                         transform: "scale(1.02)",
//                     },
//                 },
//                 "& .MuiSvgIcon-root": {
//                     color: "#64748b",
//                 },
//                 "& .MuiSelect-icon": {
//                     color: "#3b82f6",
//                 },
//             }}>
//                 <DataGridPro
//                     rows={recordForTable}
//                     columns={columns(handleStatusChange, recordStatuses)}
//                     getRowId={(row) => row.id}
//                     loading={loaderForTable}
//                     apiRef={gridApiRef}
//                     disableRowSelectionOnClick={false}
//                     rowSelectionModel={selectedRows}
//                     onRowSelectionModelChange={(newSelection) => {
//                         console.log("New Selection:", newSelection);
//                         setSelectedRows(newSelection);
//                     }}
//                     sx={{
//                         height: "calc(65vh - 40px)",
//                         border: "1px solid rgba(255, 255, 255, 0.08)",
//                         borderRadius: "16px",
//                         backgroundColor: "rgba(15, 23, 42, 0.6)",
//                         backdropFilter: "blur(20px)",
//                         boxShadow: "0 20px 60px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.1)",
//                         overflow: "hidden",

//                         // Futuristic header with neon glow
//                         "& .MuiDataGrid-columnHeaders": {
//                             background: "linear-gradient(135deg, rgba(20, 30, 60, 0.95) 0%, rgba(30, 40, 80, 0.95) 100%)",
//                             borderBottom: "2px solid rgba(0, 212, 255, 0.5)",
//                             boxShadow: "0 4px 20px rgba(0, 212, 255, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.1)",
//                             color: "#fff",
//                             fontWeight: 700,
//                             fontSize: "0.85rem",
//                             borderRadius: "16px 16px 0 0",
//                             minHeight: "60px !important",
//                             maxHeight: "60px !important",
//                             lineHeight: "60px !important",
//                             position: "relative",
//                             "&::after": {
//                                 content: '""',
//                                 position: "absolute",
//                                 bottom: 0,
//                                 left: 0,
//                                 right: 0,
//                                 height: "2px",
//                                 background: "linear-gradient(90deg, transparent 0%, #00d4ff 50%, transparent 100%)",
//                                 animation: "glow 2s ease-in-out infinite",
//                             },
//                             "@keyframes glow": {
//                                 "0%, 100%": { opacity: 0.3 },
//                                 "50%": { opacity: 1 },
//                             },
//                         },

//                         "& .MuiDataGrid-columnHeader": {
//                             outline: "none !important",
//                             borderRight: "1px solid rgba(255, 255, 255, 0.05)",
//                             "&:focus": {
//                                 outline: "none !important",
//                             },
//                             "&:focus-within": {
//                                 outline: "none !important",
//                             },
//                         },

//                         "& .MuiDataGrid-columnHeaderTitle": {
//                             color: "#00d4ff",
//                             fontWeight: 700,
//                             letterSpacing: "1.5px",
//                             textTransform: "uppercase",
//                             fontSize: "0.7rem",
//                             textShadow: "0 0 10px rgba(0, 212, 255, 0.5)",
//                         },

//                         // Glowing icons
//                         "& .MuiDataGrid-sortIcon": {
//                             color: "#00d4ff",
//                             opacity: "1 !important",
//                             filter: "drop-shadow(0 0 4px rgba(0, 212, 255, 0.8))",
//                         },

//                         "& .MuiDataGrid-menuIconButton": {
//                             color: "#00d4ff",
//                             opacity: "1 !important",
//                             filter: "drop-shadow(0 0 4px rgba(0, 212, 255, 0.8))",
//                         },

//                         "& .MuiDataGrid-iconButtonContainer": {
//                             visibility: "visible",
//                             "& .MuiIconButton-root": {
//                                 color: "#00d4ff",
//                             },
//                         },

//                         // Cyberpunk rows with neon borders
//                         "& .MuiDataGrid-row": {
//                             transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
//                             borderBottom: "1px solid rgba(255, 255, 255, 0.03)",
//                             position: "relative",
//                             "&::before": {
//                                 content: '""',
//                                 position: "absolute",
//                                 left: 0,
//                                 top: 0,
//                                 bottom: 0,
//                                 width: "0px",
//                                 background: "linear-gradient(90deg, #00d4ff 0%, #7b2ff7 100%)",
//                                 transition: "width 0.3s ease",
//                             },
//                             "&:nth-of-type(odd)": {
//                                 backgroundColor: "rgba(15, 23, 42, 0.4)",
//                             },
//                             "&:nth-of-type(even)": {
//                                 backgroundColor: "rgba(20, 30, 60, 0.3)",
//                             },
//                             "&:hover": {
//                                 backgroundColor: "rgba(0, 212, 255, 0.08)",
//                                 transform: "translateX(8px) scale(1.01)",
//                                 boxShadow: "0 0 30px rgba(0, 212, 255, 0.3), inset 0 0 20px rgba(0, 212, 255, 0.1)",
//                                 cursor: "pointer",
//                                 zIndex: 1,
//                                 "&::before": {
//                                     width: "4px",
//                                 },
//                             },
//                             "&.Mui-selected": {
//                                 backgroundColor: "rgba(123, 47, 247, 0.15) !important",
//                                 boxShadow: "inset 4px 0 0 #7b2ff7, 0 0 20px rgba(123, 47, 247, 0.3)",
//                                 "&::before": {
//                                     width: "4px",
//                                     background: "linear-gradient(180deg, #7b2ff7 0%, #f107e4 100%)",
//                                 },
//                                 "&:hover": {
//                                     backgroundColor: "rgba(123, 47, 247, 0.25) !important",
//                                     boxShadow: "inset 4px 0 0 #7b2ff7, 0 0 30px rgba(123, 47, 247, 0.5)",
//                                 },
//                             },
//                         },

//                         // Futuristic cells
//                         "& .MuiDataGrid-cell": {
//                             padding: "14px 18px",
//                             fontSize: "0.875rem",
//                             color: "#e2e8f0",
//                             borderBottom: "none",
//                             borderRight: "1px solid rgba(255, 255, 255, 0.02)",
//                             fontFamily: "'Inter', -apple-system, sans-serif",
//                             "&:focus": {
//                                 outline: "2px solid #00d4ff",
//                                 outlineOffset: "-2px",
//                                 boxShadow: "inset 0 0 10px rgba(0, 212, 255, 0.3)",
//                             },
//                         },

//                         // Neon checkboxes
//                         "& .MuiCheckbox-root": {
//                             color: "rgba(0, 212, 255, 0.4)",
//                             "&.Mui-checked": {
//                                 color: "#00d4ff",
//                                 filter: "drop-shadow(0 0 6px rgba(0, 212, 255, 0.8))",
//                             },
//                             "& .MuiSvgIcon-root": {
//                                 fontSize: "1.4rem",
//                             },
//                         },

//                         // Cyberpunk scrollbar
//                         "& .MuiDataGrid-virtualScroller": {
//                             "&::-webkit-scrollbar": {
//                                 width: "12px",
//                                 height: "12px",
//                             },
//                             "&::-webkit-scrollbar-track": {
//                                 background: "rgba(15, 23, 42, 0.5)",
//                                 borderRadius: "10px",
//                                 border: "1px solid rgba(255, 255, 255, 0.05)",
//                             },
//                             "&::-webkit-scrollbar-thumb": {
//                                 background: "linear-gradient(135deg, #00d4ff 0%, #7b2ff7 100%)",
//                                 borderRadius: "10px",
//                                 border: "2px solid rgba(15, 23, 42, 0.8)",
//                                 boxShadow: "0 0 10px rgba(0, 212, 255, 0.5)",
//                                 "&:hover": {
//                                     background: "linear-gradient(135deg, #7b2ff7 0%, #f107e4 100%)",
//                                     boxShadow: "0 0 15px rgba(123, 47, 247, 0.8)",
//                                 },
//                             },
//                         },

//                         // Dark futuristic footer
//                         "& .MuiDataGrid-footerContainer": {
//                             background: "linear-gradient(to top, rgba(10, 14, 39, 0.95) 0%, rgba(15, 23, 42, 0.9) 100%)",
//                             borderTop: "1px solid rgba(0, 212, 255, 0.3)",
//                             borderRadius: "0 0 16px 16px",
//                             minHeight: "56px",
//                             boxShadow: "0 -4px 20px rgba(0, 0, 0, 0.3)",
//                         },

//                         "& .MuiTablePagination-root": {
//                             color: "#94a3b8",
//                         },

//                         "& .MuiTablePagination-select": {
//                             borderRadius: "8px",
//                             backgroundColor: "rgba(0, 212, 255, 0.1)",
//                             border: "1px solid rgba(0, 212, 255, 0.3)",
//                             color: "#00d4ff",
//                             "&:hover": {
//                                 backgroundColor: "rgba(0, 212, 255, 0.2)",
//                                 boxShadow: "0 0 10px rgba(0, 212, 255, 0.5)",
//                             },
//                         },

//                         "& .MuiTablePagination-selectIcon": {
//                             color: "#00d4ff",
//                         },

//                         "& .MuiIconButton-root": {
//                             color: "#00d4ff",
//                             transition: "all 0.3s ease",
//                             "&:hover": {
//                                 backgroundColor: "rgba(0, 212, 255, 0.15)",
//                                 transform: "scale(1.1)",
//                                 boxShadow: "0 0 15px rgba(0, 212, 255, 0.5)",
//                             },
//                             "&.Mui-disabled": {
//                                 color: "rgba(148, 163, 184, 0.3)",
//                             },
//                         },

//                         "& .MuiDataGrid-columnSeparator": {
//                             color: "rgba(0, 212, 255, 0.2)",
//                         },

//                         // Loading overlay
//                         "& .MuiDataGrid-overlay": {
//                             background: "rgba(10, 14, 39, 0.95)",
//                             backdropFilter: "blur(10px)",
//                         },

//                         // Filter panel styling
//                         "& .MuiDataGrid-filterForm": {
//                             backgroundColor: "rgba(255, 255, 255, 0.98)",
//                             padding: "16px",
//                             borderRadius: "8px",
//                         },

//                         "& .MuiDataGrid-filterFormDeleteIcon": {
//                             color: "#ef4444",
//                             "&:hover": {
//                                 color: "#dc2626",
//                                 transform: "scale(1.1)",
//                             },
//                         },

//                         "& .MuiDataGrid-filterFormColumnInput": {
//                             backgroundColor: "rgba(255, 255, 255, 0.95)",
//                             color: "#1e293b",
//                             borderRadius: "6px",
//                         },

//                         "& .MuiDataGrid-filterFormOperatorInput": {
//                             backgroundColor: "rgba(255, 255, 255, 0.95)",
//                             color: "#1e293b",
//                             borderRadius: "6px",
//                         },

//                         "& .MuiDataGrid-filterFormValueInput": {
//                             backgroundColor: "rgba(255, 255, 255, 0.95)",
//                             color: "#1e293b",
//                             borderRadius: "6px",
//                         },

//                         // Panel styling
//                         "& .MuiDataGrid-panel": {
//                             backgroundColor: "rgba(255, 255, 255, 0.98) !important",
//                             backdropFilter: "blur(20px)",
//                             border: "1px solid rgba(59, 130, 246, 0.4)",
//                             boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3), 0 0 20px rgba(59, 130, 246, 0.3)",
//                             borderRadius: "12px",
//                         },

//                         "& .MuiDataGrid-panelHeader": {
//                             backgroundColor: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
//                             color: "#ffffff",
//                             borderBottom: "none",
//                             padding: "14px 16px",
//                             fontWeight: 700,
//                             letterSpacing: "0.5px",
//                         },

//                         "& .MuiDataGrid-panelContent": {
//                             backgroundColor: "rgba(248, 250, 252, 0.95)",
//                             color: "#1e293b",
//                             padding: "16px",
//                         },

//                         "& .MuiDataGrid-panelFooter": {
//                             backgroundColor: "rgba(241, 245, 249, 0.9)",
//                             borderTop: "1px solid rgba(226, 232, 240, 0.8)",
//                             padding: "12px 16px",
//                             "& .MuiButton-root": {
//                                 minWidth: "80px",
//                             },
//                         },
//                     }}
//                     components={{
//                         Toolbar: () => (
//                             <CustomToolbar
//                                 onSubmit={handleSubmit}
//                                 erpConnectorName={erpConnectorName}
//                                 onZoho={handleErpConnectorButton}
//                             />
//                         ),
//                         NoRowsOverlay: CustomNoRowsOverlay,
//                     }}
//                 />
//             </Box>
//             <Snackbar
//                 open={snackbar.open}
//                 autoHideDuration={6000}
//                 onClose={() => setSnackbar({ ...snackbar, open: false })}
//                 anchorOrigin={{ vertical: "top", horizontal: "right" }}
//             >
//                 <Alert
//                     onClose={() => setSnackbar({ ...snackbar, open: false })}
//                     severity={snackbar.severity}
//                     sx={{ 
//                         width: "100%",
//                         borderRadius: "12px",
//                         boxShadow: "0 8px 32px rgba(0, 0, 0, 0.4), 0 0 20px rgba(0, 212, 255, 0.3)",
//                         backgroundColor: "rgba(15, 23, 42, 0.95)",
//                         color: "#e2e8f0",
//                         border: "1px solid rgba(0, 212, 255, 0.3)",
//                         backdropFilter: "blur(10px)",
//                     }}
//                 >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </>
//     );
// };

// const COAReport = ({
//     recordForTable,
//     loaderForTable,
//     getApiImsReport,
//     gridApiRef,
//     erpConnectorName,
//     setZohoTriggerForDebit
// }) => {
//     const [snackbar, setSnackbar] = useState({
//         open: false,
//         message: "",
//         severity: "info",
//     });
//     const [recordStatuses, setRecordStatuses] = useState(
//         recordForTable.reduce((acc, row) => {
//             acc[row.id] = {
//                 status: row.status || "",
//                 p_and_l_type: row.p_and_l_type || "",
//                 gst_applicable: row.gst_applicable || "",
//                 tds_applicable: row.tds_applicable || "",
//                 tcs_applicable: row.tcs_applicable || "",
//                 gst_type_of_supply: row.gst_type_of_supply || "",
//                 gst_nature_of_supply: row.gst_nature_of_supply || "",
//             };
//             return acc;
//         }, {})
//     );
//     const [selectedRows, setSelectedRows] = useState([]);

//     useEffect(() => {
//         setRecordStatuses(
//             recordForTable.reduce((acc, row) => {
//                 acc[row.id] = {
//                     status: row.status || "",
//                     p_and_l_type: row.p_and_l_type || "",
//                     gst_applicable: row.gst_applicable || "",
//                     tds_applicable: row.tds_applicable || "",
//                     tcs_applicable: row.tcs_applicable || "",
//                     gst_type_of_supply: row.gst_type_of_supply || "",
//                     gst_nature_of_supply: row.gst_nature_of_supply || "",
//                 };
//                 return acc;
//             }, {})
//         );
//         setSelectedRows([]);
//     }, [recordForTable]);

//     const handleStatusChange = (id, field, newValue) => {
//         setRecordStatuses((prev) => ({
//             ...prev,
//             [id]: { ...prev[id], [field]: newValue },
//         }));
//         if (!selectedRows.includes(id)) {
//             setSelectedRows((prev) => [...prev, id]);
//         }
//     };

//     const handleSubmit = async () => {
//         const selectedRowsData = selectedRows
//             .map((id) => recordForTable.find((row) => row.id === id))
//             .filter(Boolean);

//         console.log("Selected Rows:", selectedRowsData);
//         console.log("Record Statuses:", recordStatuses);

//         if (selectedRowsData.length === 0) {
//             setSnackbar({
//                 open: true,
//                 message: "Please select at least one record to submit.",
//                 severity: "warning",
//             });
//             return;
//         }

//         const payload = {
//             business_entity_id: localStorage.getItem("business_entity_id"),
//             records: selectedRowsData.map((row) => ({
//                 id: row.id,
//                 entity_gstn: row.entity_gstn,
//                 branch_name: row.branch_name,
//                 category: row.category,
//                 cwn_coa_id: row.cwn_coa_id,
//                 fs_type: row.fs_type,
//                 ledger_group_1: row.ledger_group_1,
//                 ledger_group_2: row.ledger_group_2,
//                 ledger_group_3: row.ledger_group_3,
//                 ledger_group_4: row.ledger_group_4,
//                 ledger_id: row.ledger_id,
//                 ledger_code: row.ledger_code,
//                 p_and_l_type: recordStatuses[row.id]?.p_and_l_type || row.p_and_l_type || null,
//                 ledger_name: row.ledger_name,
//                 gst_applicable: recordStatuses[row.id]?.gst_applicable || row.gst_applicable || null,
//                 tds_applicable: recordStatuses[row.id]?.tds_applicable || row.tds_applicable || null,
//                 tcs_applicable: recordStatuses[row.id]?.tcs_applicable || row.tcs_applicable || null,
//                 gst_type_of_supply: recordStatuses[row.id]?.gst_type_of_supply || row.gst_type_of_supply || null,
//                 gst_nature_of_supply: recordStatuses[row.id]?.gst_nature_of_supply || row.gst_nature_of_supply || null,
//                 tds_section_number: row.tds_section_number,
//                 tcs_section_number: row.tcs_section_number,
//                 hsn_code: row.hsn_code,
//                 igst_rate: row.igst_rate,
//                 cgst_rate: row.cgst_rate,
//                 sgst_rate: row.sgst_rate,
//                 cess_rate: row.cess_rate,
//                 opening_balance: row.opening_balance,
//                 status: row.status,
//             })),
//         };

//         console.log("Payload:", JSON.stringify(payload, null, 2));

//         try {
//             const res = await axios.post("/arc/update/coa", payload);
//             setSnackbar({
//                 open: true,
//                 message: "Selected records submitted successfully",
//                 severity: "success",
//             });
//             if (getApiImsReport) {
//                 await getApiImsReport();
//             }
//             setSelectedRows([]);
//         } catch (error) {
//             setSnackbar({
//                 open: true,
//                 message: error.response?.data?.message || "Error submitting selected records",
//                 severity: "error",
//             });
//         }
//     };

//     const handleErpConnectorButton = () => {
//         console.log("true");
//         setZohoTriggerForDebit({
//             messageForConnection: "Establish Connection",
//             buttonColor: "red",
//             zohoShowButton: true,
//         });
//     };

//     return (
//         <>
//             <Box sx={{
//                 height: "65vh",
//                 width: "100%",
//                 marginTop: "4px",
//                 padding: "16px",
//                 background: "linear-gradient(135deg, #f5f7fa 0%, #e8eef5 100%)",
//                 borderRadius: "16px",
//             }}>
//                 <DataGridPro
//                     rows={recordForTable}
//                     columns={columns(handleStatusChange, recordStatuses)}
//                     getRowId={(row) => row.id}
//                     loading={loaderForTable}
//                     apiRef={gridApiRef}
//                     disableRowSelectionOnClick={false}
//                     rowSelectionModel={selectedRows}
//                     onRowSelectionModelChange={(newSelection) => {
//                         console.log("New Selection:", newSelection);
//                         setSelectedRows(newSelection);
//                     }}
//                     sx={{
//                         height: "calc(65vh - 32px)",
//                         border: "none",
//                         borderRadius: "12px",
//                         backgroundColor: "rgba(255, 255, 255, 0.9)",
//                         backdropFilter: "blur(10px)",
//                         boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)",
//                         overflow: "hidden",

//                         // Header styling with gradient
//                         "& .MuiDataGrid-columnHeaders": {
//                             background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                             color: "#fff",
//                             fontWeight: 600,
//                             fontSize: "0.9rem",
//                             borderRadius: "12px 12px 0 0",
//                             borderBottom: "none",
//                             minHeight: "56px !important",
//                             maxHeight: "56px !important",
//                             lineHeight: "56px !important",
//                         },

//                         "& .MuiDataGrid-columnHeader": {
//                             outline: "none !important",
//                             "&:focus": {
//                                 outline: "none !important",
//                             },
//                             "&:focus-within": {
//                                 outline: "none !important",
//                             },
//                         },

//                         "& .MuiDataGrid-columnHeaderTitle": {
//                             color: "#fff",
//                             fontWeight: 600,
//                             letterSpacing: "0.5px",
//                             textTransform: "uppercase",
//                             fontSize: "0.75rem",
//                         },

//                         // Icons in header
//                         "& .MuiDataGrid-sortIcon": {
//                             color: "rgba(255, 255, 255, 0.9)",
//                             opacity: "1 !important",
//                         },

//                         "& .MuiDataGrid-menuIconButton": {
//                             color: "rgba(255, 255, 255, 0.9)",
//                             opacity: "1 !important",
//                         },

//                         "& .MuiDataGrid-iconButtonContainer": {
//                             visibility: "visible",
//                             "& .MuiIconButton-root": {
//                                 color: "rgba(255, 255, 255, 0.9)",
//                             },
//                         },

//                         // Row styling with smooth transitions
//                         "& .MuiDataGrid-row": {
//                             transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//                             borderBottom: "1px solid rgba(224, 224, 224, 0.4)",
//                             "&:nth-of-type(odd)": {
//                                 backgroundColor: "rgba(255, 255, 255, 0.5)",
//                             },
//                             "&:nth-of-type(even)": {
//                                 backgroundColor: "rgba(248, 250, 252, 0.5)",
//                             },
//                             "&:hover": {
//                                 backgroundColor: "rgba(102, 126, 234, 0.08)",
//                                 transform: "scale(1.001)",
//                                 boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
//                                 cursor: "pointer",
//                             },
//                             "&.Mui-selected": {
//                                 backgroundColor: "rgba(102, 126, 234, 0.15) !important",
//                                 borderLeft: "4px solid #667eea",
//                                 "&:hover": {
//                                     backgroundColor: "rgba(102, 126, 234, 0.25) !important",
//                                 },
//                             },
//                         },

//                         // Cell styling
//                         "& .MuiDataGrid-cell": {
//                             padding: "12px 16px",
//                             fontSize: "0.875rem",
//                             color: "#334155",
//                             borderBottom: "none",
//                             "&:focus": {
//                                 outline: "2px solid #667eea",
//                                 outlineOffset: "-2px",
//                             },
//                         },

//                         // Checkbox styling
//                         "& .MuiCheckbox-root": {
//                             color: "#94a3b8",
//                             "&.Mui-checked": {
//                                 color: "#667eea",
//                             },
//                             "& .MuiSvgIcon-root": {
//                                 fontSize: "1.3rem",
//                             },
//                         },

//                         // Virtual scroller
//                         "& .MuiDataGrid-virtualScroller": {
//                             "&::-webkit-scrollbar": {
//                                 width: "8px",
//                                 height: "8px",
//                             },
//                             "&::-webkit-scrollbar-track": {
//                                 background: "rgba(0, 0, 0, 0.05)",
//                                 borderRadius: "10px",
//                             },
//                             "&::-webkit-scrollbar-thumb": {
//                                 background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                                 borderRadius: "10px",
//                                 "&:hover": {
//                                     background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
//                                 },
//                             },
//                         },

//                         // Footer styling
//                         "& .MuiDataGrid-footerContainer": {
//                             background: "linear-gradient(to right, #f8fafc 0%, #f1f5f9 100%)",
//                             borderTop: "1px solid rgba(224, 224, 224, 0.4)",
//                             borderRadius: "0 0 12px 12px",
//                             minHeight: "52px",
//                         },

//                         "& .MuiTablePagination-root": {
//                             color: "#64748b",
//                         },

//                         "& .MuiTablePagination-select": {
//                             borderRadius: "8px",
//                             "&:hover": {
//                                 backgroundColor: "rgba(102, 126, 234, 0.1)",
//                             },
//                         },

//                         "& .MuiTablePagination-selectIcon": {
//                             color: "#667eea",
//                         },

//                         "& .MuiIconButton-root": {
//                             color: "#667eea",
//                             "&:hover": {
//                                 backgroundColor: "rgba(102, 126, 234, 0.1)",
//                             },
//                             "&.Mui-disabled": {
//                                 color: "#cbd5e1",
//                             },
//                         },

//                         // Column separator
//                         "& .MuiDataGrid-columnSeparator": {
//                             color: "rgba(255, 255, 255, 0.3)",
//                         },

//                         // Loading overlay
//                         "& .MuiDataGrid-overlay": {
//                             background: "rgba(255, 255, 255, 0.9)",
//                             backdropFilter: "blur(4px)",
//                         },
//                     }}
//                     components={{
//                         Toolbar: () => (
//                             <CustomToolbar
//                                 onSubmit={handleSubmit}
//                                 erpConnectorName={erpConnectorName}
//                                 onZoho={handleErpConnectorButton}
//                             />
//                         ),
//                         NoRowsOverlay: CustomNoRowsOverlay,
//                     }}
//                 />
//             </Box>
//             <Snackbar
//                 open={snackbar.open}
//                 autoHideDuration={6000}
//                 onClose={() => setSnackbar({ ...snackbar, open: false })}
//                 anchorOrigin={{ vertical: "top", horizontal: "right" }}
//             >
//                 <Alert
//                     onClose={() => setSnackbar({ ...snackbar, open: false })}
//                     severity={snackbar.severity}
//                     sx={{
//                         width: "100%",
//                         borderRadius: "12px",
//                         boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
//                     }}
//                 >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </>
//     );
// };

// const COAReport = ({
//     recordForTable,
//     loaderForTable,
//     getApiImsReport,
//     gridApiRef,
//     erpConnectorName,
//     setZohoTriggerForDebit // Use the prop passed from parent
// }) => {
//     const [snackbar, setSnackbar] = useState({
//         open: false,
//         message: "",
//         severity: "info",
//     });
//     const [recordStatuses, setRecordStatuses] = useState(
//         recordForTable.reduce((acc, row) => {
//             acc[row.id] = {
//                 status: row.status || "",
//                 p_and_l_type: row.p_and_l_type || "",
//                 gst_applicable: row.gst_applicable || "",
//                 tds_applicable: row.tds_applicable || "",
//                 tcs_applicable: row.tcs_applicable || "",
//                 gst_type_of_supply: row.gst_type_of_supply || "",
//                 gst_nature_of_supply: row.gst_nature_of_supply || "",
//             };
//             return acc;
//         }, {})
//     );
//     const [selectedRows, setSelectedRows] = useState([]);

//     useEffect(() => {
//         // Initialize recordStatuses when recordForTable changes
//         setRecordStatuses(
//             recordForTable.reduce((acc, row) => {
//                 acc[row.id] = {
//                     status: row.status || "",
//                     p_and_l_type: row.p_and_l_type || "",
//                     gst_applicable: row.gst_applicable || "",
//                     tds_applicable: row.tds_applicable || "",
//                     tcs_applicable: row.tcs_applicable || "",
//                     gst_type_of_supply: row.gst_type_of_supply || "",
//                     gst_nature_of_supply: row.gst_nature_of_supply || "",
//                 };
//                 return acc;
//             }, {})
//         );
//         // Reset selected rows when data changes to avoid stale IDs
//         setSelectedRows([]);
//     }, [recordForTable]);

//     const handleStatusChange = (id, field, newValue) => {
//         setRecordStatuses((prev) => ({
//             ...prev,
//             [id]: { ...prev[id], [field]: newValue },
//         }));
//         // Ensure the row is selected when its dropdown is changed
//         if (!selectedRows.includes(id)) {
//             setSelectedRows((prev) => [...prev, id]);
//         }
//     };

//     const handleSubmit = async () => {
//         // Get selected rows from the DataGridPro
//         const selectedRowsData = selectedRows
//             .map((id) => recordForTable.find((row) => row.id === id))
//             .filter(Boolean); // Filter out undefined rows

//         console.log("Selected Rows:", selectedRowsData);
//         console.log("Record Statuses:", recordStatuses); // Debug log

//         if (selectedRowsData.length === 0) {
//             setSnackbar({
//                 open: true,
//                 message: "Please select at least one record to submit.",
//                 severity: "warning",
//             });
//             return;
//         }

//         const payload = {
//             business_entity_id: localStorage.getItem("business_entity_id"),
//             records: selectedRowsData.map((row) => ({
//                 id: row.id,
//                 entity_gstn: row.entity_gstn,
//                 branch_name: row.branch_name,
//                 category: row.category,
//                 cwn_coa_id: row.cwn_coa_id,
//                 fs_type: row.fs_type,
//                 ledger_group_1: row.ledger_group_1,
//                 ledger_group_2: row.ledger_group_2,
//                 ledger_group_3: row.ledger_group_3,
//                 ledger_group_4: row.ledger_group_4,
//                 ledger_id: row.ledger_id,
//                 ledger_code: row.ledger_code,
//                 p_and_l_type: recordStatuses[row.id]?.p_and_l_type || row.p_and_l_type || null,
//                 ledger_name: row.ledger_name,
//                 gst_applicable: recordStatuses[row.id]?.gst_applicable || row.gst_applicable || null,
//                 tds_applicable: recordStatuses[row.id]?.tds_applicable || row.tds_applicable || null,
//                 tcs_applicable: recordStatuses[row.id]?.tcs_applicable || row.tcs_applicable || null,
//                 gst_type_of_supply: recordStatuses[row.id]?.gst_type_of_supply || row.gst_type_of_supply || null,
//                 gst_nature_of_supply: recordStatuses[row.id]?.gst_nature_of_supply || row.gst_nature_of_supply || null,
//                 tds_section_number: row.tds_section_number,
//                 tcs_section_number: row.tcs_section_number,
//                 hsn_code: row.hsn_code,
//                 igst_rate: row.igst_rate,
//                 cgst_rate: row.cgst_rate,
//                 sgst_rate: row.sgst_rate,
//                 cess_rate: row.cess_rate,
//                 opening_balance: row.opening_balance,
//                 status: row.status,
//             })),
//         };

//         console.log("Payload:", JSON.stringify(payload, null, 2)); // Debug log

//         try {
//             const res = await axios.post("/arc/update/coa", payload);
//             setSnackbar({
//                 open: true,
//                 message: "Selected records submitted successfully",
//                 severity: "success",
//             });
//             if (getApiImsReport) {
//                 await getApiImsReport();
//             }
//             // Clear selected rows after successful submission
//             setSelectedRows([]);
//         } catch (error) {
//             setSnackbar({
//                 open: true,
//                 message: error.response?.data?.message || "Error submitting selected records",
//                 severity: "error",
//             });
//         }
//     };

//     const handleErpConnectorButton = () => {
//         console.log("true");
//         setZohoTriggerForDebit({
//             messageForConnection: "Establish Connection",
//             buttonColor: "red",
//             zohoShowButton: true,
//         });
//     };

//     return (
//         <>
//             <Box sx={{ height: "65vh", width: "100%", marginTop: "4px" }}>
//                 <DataGridPro
//                     rows={recordForTable}
//                     columns={columns(handleStatusChange, recordStatuses)}
//                     getRowId={(row) => row.id}
//                     loading={loaderForTable}
//                     apiRef={gridApiRef}
//                     disableRowSelectionOnClick={false}
//                     rowSelectionModel={selectedRows}
//                     onRowSelectionModelChange={(newSelection) => {
//                         console.log("New Selection:", newSelection); // Debug log
//                         setSelectedRows(newSelection);
//                     }}
//                     sx={{
//                         maxHeight: "65vh",
//                         "& .MuiDataGrid-columnHeaders": {
//                             color: "#fff",
//                             fontWeight: "bold",
//                             cursor: "pointer",
//                             zIndex: 1000,
//                         },
//                         "& .MuiDataGrid-columnHeader": {
//                             position: "relative",
//                             textAlign: "center",
//                             width: "100%",
//                             fontWeight: "bold",
//                             backgroundColor: "#607d8b",
//                         },
//                         "& .MuiDataGrid-columnHeaderTitle": {
//                             color: "#fff",
//                         },
//                         "& .MuiDataGrid-sortIcon": {
//                             opacity: "inherit !important",
//                         },
//                         "& .MuiDataGrid-iconButtonContainer": {
//                             visibility: "visible",
//                         },
//                         "& .MuiDataGrid-menuIconButton": {
//                             opacity: "1 !important",
//                             visibility: "visible !important",
//                             display: "flex !important",
//                         },
//                         "& .MuiDataGrid-row:nth-of-type(odd)": {
//                             backgroundColor: "#f9f9f9",
//                         },
//                         "& .MuiDataGrid-row:nth-of-type(even)": {
//                             backgroundColor: "#ffffff",
//                         },
//                         "& .MuiDataGrid-cell": {
//                             padding: "8px",
//                             textAlign: "center",
//                         },
//                         "& .MuiDataGrid-footerContainer": {
//                             backgroundColor: "#f0f0f0",
//                         },
//                         "& .MuiDataGrid-row:hover": {
//                             backgroundColor: "#d3e3fc",
//                             cursor: "pointer",
//                         },
//                         "& .MuiDataGrid-row.Mui-selected": {
//                             backgroundColor: "#bbdefb",
//                             "&:hover": {
//                                 backgroundColor: "#90caf9",
//                             },
//                         },
//                         "& .MuiDataGrid-cell:focus": {
//                             outline: "none",
//                         },
//                     }}
//                     components={{
//                         Toolbar: () => (
//                             <CustomToolbar
//                                 onSubmit={handleSubmit}
//                                 erpConnectorName={erpConnectorName}
//                                 onZoho={handleErpConnectorButton}
//                             />
//                         ),
//                         NoRowsOverlay: CustomNoRowsOverlay,
//                     }}
//                 />
//             </Box>
//             <Snackbar
//                 open={snackbar.open}
//                 autoHideDuration={6000}
//                 onClose={() => setSnackbar({ ...snackbar, open: false })}
//                 anchorOrigin={{ vertical: "top", horizontal: "right" }}
//             >
//                 <Alert
//                     onClose={() => setSnackbar({ ...snackbar, open: false })}
//                     severity={snackbar.severity}
//                     sx={{ width: "100%" }}
//                 >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </>
//     );
// };

export default function COAManagement() {
    let flagForDebitNote = 1;
    const classes = useStyles();
    const location = useLocation();
    const [url, setUrl] = useState("");
    const gridApiRef = useGridApiRef();
    const reconid = location.state?.reconid;
    const [uploadCOA, setUploadCOA] = useState(false);
    const [recordForTable, setRecordForTable] = useState([]);
    const [recordForLogTable, setRecordForLogTable] = useState([]);
    const [loaderForTable, setLoaderForTable] = useState(false);
    const [reconId, setReconId] = useState(reconid);
    const [fileName, setFileName] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileDataToUpload, setFileDataToUpload] = useState("");
    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);
    const [isExportingCOA, setIsExportingCOA] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadState, setUploadState] = useState("idle");
    const [timers, setTimers] = useState(60);
    const [zohoDate, setZohoDate] = useState({});
    const [submitLoaderForDebit, setSubmitLoaderForDebit] = useState(false);
    const [grantToken, setGrantToken] = useState("");
    const [importToCwsLoading, setImportToCwsLoading] = useState(false);
    const [showUploadHistoryTable, setShowUploadHistoryTable] = useState(false);
    const [erpConnectorModelOpen, setErpConnectorModelOpen] = useState(false);
    const [erpDataExportLoading, setErpDataExportLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "info",
    });
    const [zohoTriggerForDebit, setZohoTriggerForDebit] = useState({
        messageForConnection: "Establish Connection",
        buttonColor: "red",
        zohoShowButton: false,
    });

    const [autoSync, setAutoSync] = useState(false);

    const [pagination, setPagination] = useState({
        page: 0,
        rowsPerPage: 10,
        total_count: 0,
        total_pages: 1,
    });

    let timerforZoho = useRef();

    const handleDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragActive(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragActive(false);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragActive(false);

        const files = e.dataTransfer.files;
        if (files && files.length > 0) {
            const file = files[0];
            const validTypes = [".xlsx", ".xls", ".csv"];
            const fileExtension = "." + file.name.split(".").pop().toLowerCase();

            if (validTypes.includes(fileExtension)) {
                const syntheticEvent = {
                    target: { files: [file] },
                };
                handleFileChange(syntheticEvent);
            }
        }
    };

    const exportToExcel = (Data, erpExport = false) => {
        let Datas = {};
        if (zohoTriggerForDebit.zohoShowButton) {
            Datas = {
                business_entity_id: localStorage.getItem("business_entity_id"),
                // daybook_type: "Zoho",
                log_id: localStorage.getItem("zoho_log_id"),
            };
        } else {
            Datas = {
                business_entity_id: localStorage.getItem("business_entity_id"),
            };
        }
        if (erpExport) {
            Datas['zoho_data'] = Data;
        }

        const contentType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = `chart_of_accounts.xlsx`;

        axios
            .post("/zoho_chart_of_accounts_export/download", Datas)
            .then((res) => {
                downloadBase64File(contentType, res.data.file, filename);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setErpDataExportLoading(false);
            });
    };

const zohoDateChangeHandler = (item) => {
  const { name, value } = item;

  var d = new Date(value);
  var newd = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  let dateValue = newd.toISOString().replace("Z", "");

  setZohoDate((prev) => ({
    ...prev,
    [name]: dateValue,
  }));
};

    const handleAutoSyncChange = (checked) => {
        setAutoSync(checked);
    };

    const fetchingdataForZoho = () => {
        clearInterval(timerforZoho.current);
        flagForDebitNote += 1;

        setSubmitLoaderForDebit(true);
        axios
            .post("/arc/zoho_import", {
                business_entity_id: localStorage.getItem("business_entity_id"),
                code: grantToken,
                type_of_data: "chart_of_accounts",
                redirect_uri: `${url}/zohoTesting`,
                date: zohoDate,
                auto_sync: autoSync,
            })
            .then((res) => {
                if (res.data.status === true) {
                    setSubmitLoaderForDebit(false);
                    setZohoTriggerForDebit({
                        messageForConnection: "Establish Connection",
                        buttonColor: "red",
                        zohoShowButton: true,
                    });
                    setZohoDate({});
                    setAutoSync(false);
                } else {
                    setZohoTriggerForDebit({
                        messageForConnection: "Establish Connection",
                        buttonColor: "red",
                        zohoShowButton: true,
                    });
                    setZohoDate({});
                    setSubmitLoaderForDebit(false);
                    setAutoSync(false);
                }
            })
            .catch((err) => {
                setZohoTriggerForDebit({
                    messageForConnection: "Establish Connection",
                    buttonColor: "red",
                    zohoShowButton: true,
                });
                setZohoDate({});
                setSubmitLoaderForDebit(false);
                setAutoSync(false);
            });
    };

    const establishConnection = (e) => {
        console.log("[daybook] establishing connection with zoho");
        e.preventDefault();
        window.location.href = `https://accounts.zoho.in/oauth/v2/auth?scope=ZohoBooks.fullaccess.READ&client_id=${localStorage.getItem(
            "Client_ID"
        )}&state=testing&response_type=code&redirect_uri=${url}/zohoTesting&access_type=offline&prompt=Consent`;
    };

    const closeZohoDrawer = () => {
        clearInterval(timerforZoho.current);
        setZohoTriggerForDebit({
            messageForConnection: "Establish Connection",
            buttonColor: "red",
            zohoShowButton: false,
        });
        setZohoDate({});
        setSubmitLoaderForDebit(false);
        localStorage.setItem("DrawerForDebit", "false");
    };

    const getApiForClientID = () => {
        axios
            .get(`/connection_info/${localStorage.getItem("business_entity_id")}`)
            .then((res) => {
                res?.data?.record
                    .filter((v) => v.source_system === "ZOHO")
                    .map((value) =>
                        localStorage.setItem("Client_ID", value.connection_info.client_id)
                    );
                res?.data?.record.filter((v) => {
                    if (v.source_system === "Effitrac" || v.source_system === "Tally") {
                        localStorage.setItem("Trigger_Effitrac/Tally_Button", "true");
                    }
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleImportToCWS = (dataFromZoho, uploadType = "Zoho") => {
        setImportToCwsLoading(true);
        let payLoadData = {};
        if (uploadType !== "Zoho") {
            payLoadData = {
                business_entity_id: localStorage.getItem("business_entity_id"),
                coa_type: "Zoho",
                log_id: localStorage.getItem("zoho_log_id"),
            };
        } else {
            payLoadData = {
                business_entity_id: localStorage.getItem("business_entity_id"),
                coa_type: "Zoho",
                log_id: localStorage.getItem("zoho_log_id"),
            };
        }
        axios
            .post(`/zoho_chart_of_accounts_export/import_cws`, payLoadData)
            .then((res) => {
                setShowUploadHistoryTable(true);
                // setOpenSnackbar("Uploading Files Into Database");
                setSnackbar({
                    open: true,
                    message: "Uploading Files Into Database",
                    severity: "success",
                });
            })
            .finally(() => {
                setImportToCwsLoading(false);
                closeErpDrawer();
            });
    };

    const closeErpDrawer = () => {
        setErpConnectorModelOpen(false);
    };

    const handleFileChange = (e) => {
        if (e.target.files.length) {
            const file_data = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(file_data);
            reader.onload = () => {
                // Trigger upload with the actual data
                handleFileUploadWithAnimation(file_data, reader.result, file_data.name);
            };
            e.target.value = null;
        }
    };

    const handleFileUploadWithAnimation = async (file, fileData, fileName) => {
        try {
            setUploadState("uploading");
            setUploadProgress(0);
            const progressInterval = setInterval(() => {
                setUploadProgress((prev) => {
                    if (prev >= 90) {
                        clearInterval(progressInterval);
                        return 90;
                    }
                     return Math.min(99, Math.round(prev + Math.random() * 15));
                });
            }, 150);
            await handleFileUpload(file, fileData, fileName);
            clearInterval(progressInterval);
            setUploadProgress(100);
            setTimeout(() => {
                setUploadState("success");
                setTimeout(() => {
                    setUploadState("idle");
                    setUploadProgress(0);
                }, 3000);
            }, 500);
        } catch (error) {
            setUploadState("error");
            setSnackbar({
                open: true,
                message: "Upload failed. Please try again.",
                severity: "error",
            });
        }
    };

    const handleFileUpload = async (file, fileData, fileName) => {
        if (!file) {
            setSnackbar({
                open: true,
                message: "Please select a file first.",
                severity: "error",
            });
            return;
        }
        const payLoadData = {
            business_entity_id: localStorage.getItem("business_entity_id"),
            file: fileData,
            document_name: fileName,
        };
        setIsLoading(true);
        try {
            const response = await axios.post("/arc/excelupload/coa", payLoadData);
            setMessage(response?.data?.message || "File uploaded successfully");
            setSnackbar({
                open: true,
                message: response?.data?.message || "File uploaded successfully",
                severity: "success",
            });
            getManualLog();
        } catch (error) {
            setMessage("Error uploading file.");
            setSnackbar({
                open: true,
                message: error.response?.data?.message || "Error uploading file.",
                severity: "error",
            });
        } finally {
            setSelectedFile(null);
            setFileDataToUpload("");
            setIsLoading(false);
        }
    };

    const renderUploadIcon = () => {
        const circumference = 2 * Math.PI * 35;
        const strokeDashoffset = circumference - (uploadProgress / 100) * circumference;

        switch (uploadState) {
            case "uploading":
                return (
                    <div className="upload-icon-container">
                        <Typography
                            variant="h6"
                            style={{ color: "#2196f3", fontWeight: "bold" }}
                        >
                            {Math.round(uploadProgress)}%
                        </Typography>
                    </div>
                );

            case "success":
                return (
                    <div className="upload-icon-container">
                        <div className="success-circle">
                            <svg width="40" height="40" viewBox="0 0 40 40">
                                <path className="checkmark" d="M10 20 L18 28 L30 12" />
                            </svg>
                        </div>
                    </div>
                );

            default:
                return (
                    <div className="upload-icon-container">
                        <CloudUploadIcon sx={{ fontSize: 40, color: "#bdbdbd" }} />
                    </div>
                );
        }
    };

    const getUploadText = () => {
        switch (uploadState) {
            case "uploading":
                return "Uploading your file...";
            case "success":
                return "Upload completed successfully!";
            case "error":
                return "Upload failed. Please try again.";
            default:
                return "Drag files to upload, or";
        }
    };

    const handleToggleChange = () => {
        const newUploadCOA = !uploadCOA;
        setUploadCOA(newUploadCOA);
        if (newUploadCOA) {
            getManualLog();
        }
    };

    const getManualLog = async () => {
        const business_entity_id = localStorage.getItem("business_entity_id");
        try {
            const res = await axios.get(`/arc/get_data_upload_history/${business_entity_id}/20`);
            const data = res.data.record || [];

            if (data.length > 0) {
                localStorage.setItem("upload_history_id", data[0].id);
                setRecordForLogTable(data);
            } else {
                setSnackbar({
                    open: true,
                    message: "No records found",
                    severity: "error",
                });
            }
        } catch (error) {
            setSnackbar({
                open: true,
                message: error.response?.data?.message || "Error fetching upload history",
                severity: "error",
            });
            setRecordForLogTable([]);
        } finally {
            setLoaderForTable(false);
        }
    };

    const onClickRefresh = () => {
        getApiCoa(reconId, pagination.page, pagination.rowsPerPage);
        getManualLog();
    };

    const getApiCoa = async (reconid, page = 0, rowsPerPage = 10) => {
        try {
            const res = await axios.get(
                `/get_coa_details/${localStorage.getItem("business_entity_id")}`
            );
            if (res.data.status && Array.isArray(res.data.records)) {
                setRecordForTable(res.data.records);
            } else {
                setSnackbar({
                    open: true,
                    message: "Invalid API response: Expected records array",
                    severity: "error",
                });
            }
        } catch (error) {
            setSnackbar({
                open: true,
                message: error.response?.data?.message || "Error fetching COA details",
                severity: "error",
            });
        } finally {
            setLoaderForTable(false);
        }
    };

    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };

    const onExport = () => {
        const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = `Chart of Account.xlsx`;

        setIsExportingCOA(true);
        axios
            .get(`/get_coa_report/${localStorage.getItem("business_entity_id")}`)
            .then((res) => {
                downloadBase64File(contentType, res.data.file, filename);
            })
            .catch((error) => {
                console.error("Export error:", error);
                setSnackbar({
                    open: true,
                    message: error.response?.data?.message || "Failed to export to Excel",
                    severity: "error",
                });
            })
            .finally(() => {
                setIsExportingCOA(false);
            });
    };

    useEffect(() => {
        // getManualLog();
    })

    useEffect(() => {
        getApiCoa(reconId, pagination.page, pagination.rowsPerPage);
        getManualLog();
    }, [reconId, pagination.page, pagination.rowsPerPage]);
    getApiForClientID();


    return (
        <Box sx={{ width: "100%", padding: 2 }}>
            <style>{uploadStyles}</style>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    fontFamily: "'Roboto', sans-serif",
                    width: "100%",
                    mb: 2,
                }}
            >
                <>
                    {/* Back arrow on the left */}
                    <Tooltip title="Back" arrow>
                        <IconButton
                            onClick={() => window.history.back()}
                            sx={{
                                borderRadius: '50%',
                                padding: '6px',
                                color: '#263238',
                                backgroundColor: '#ffffff',
                                height: '36px',
                                width: '36px',
                                '&:hover': {
                                    backgroundColor: '#455a64',
                                    color: '#ffffff',
                                },
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                                transition: 'background-color 0.3s ease',
                            }}
                        >
                            <ArrowBackIcon sx={{ fontSize: '20px' }} />
                        </IconButton>
                    </Tooltip>

                    <Box sx={{ flexGrow: 1 }} />

                    <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <a href={chartofaccounts} download="Chart of Accounts.xlsx" style={{ textDecoration: "none" }}>
                            <button
                                className="button-outlined-primary"
                                style={{ height: '59%', marginTop: '1%', whiteSpace: 'nowrap' }}
                            >
                                Download Template
                            </button>
                        </a>

                        {(localStorage.getItem('is_uploads') === "N") && <Box sx={{ flexGrow: 1 }} />}

                        <button
                            className="button-outlined-primary"
                            style={{
                                height: '59%',
                                marginTop: '1%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '6px',
                                minWidth: '90px',
                            }}
                            onClick={onExport}
                            disabled={isExportingCOA}
                        >
                            {isExportingCOA ? (
                                <>
                                    <span
                                        style={{
                                            width: "12px",
                                            height: "12px",
                                            border: "2px solid currentColor",
                                            borderTopColor: "transparent",
                                            borderRadius: "50%",
                                            display: "inline-block",
                                            animation: "spin 0.7s linear infinite",
                                            flexShrink: 0,
                                        }}
                                    />
                                    Exporting...
                                </>
                            ) : (
                                "Export"
                            )}
                        </button>

                        {/* closing the wrapper */}
                    </Box>

                </>
                {/* )} */}
            </Box>
            {/* {uploadCOA && ( */}
            <Box sx={{ width: "100%", margin: "0 auto" }}>

                {/* Log Table */}
                <Box sx={{ marginBottom: "20px" }}>
                    <LogTable
                        recordForLogTable={recordForLogTable}
                        loaderForTable={loaderForTable}
                        getManualLog={getManualLog}
                        setSnackbar={setSnackbar}
                        onClickRefresh={onClickRefresh}
                        uploadState={uploadState}
                        uploadProgress={uploadProgress}
                        selectedFile={selectedFile}
                        handleFileChange={handleFileChange}
                        handleFileUploadWithAnimation={handleFileUploadWithAnimation}
                        erpConnectorName="Zoho"
                        onErpConnectorClick={() => {
                            setZohoTriggerForDebit({
                                messageForConnection: "Establish Connection",
                                buttonColor: "red",
                                zohoShowButton: true,
                            });
                        }}
                    />
                    {/* <LogTable
                            recordForLogTable={recordForLogTable}
                            loaderForTable={loaderForTable}
                            getManualLog={getManualLog}
                            setSnackbar={setSnackbar}
                            onClickRefresh={onClickRefresh}
                        /> */}
                </Box>

                <style>
                    {`
            @keyframes scaleIn {
                0% {
                    transform: scale(0);
                    opacity: 0;
                }
                50% {
                    transform: scale(1.2);
                }
                100% {
                    transform: scale(1);
                    opacity: 1;
                }
            }
        `}
                </style>
            </Box>

            {/* )} */}
            <COAReport
                recordForTable={recordForTable}
                loaderForTable={loaderForTable}
                gridApiRef={gridApiRef}
                getApiImsReport={() =>
                    reconId && getApiCoa(reconId, 0, pagination.rowsPerPage)
                }
                erpConnectorName="" // Example ERP connector name
                setZohoTriggerForDebit={setZohoTriggerForDebit}
            />
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                    severity={snackbar.severity}
                    sx={{ width: "100%" }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>

            <ZohoModel
                openZohoDrawer={zohoTriggerForDebit.zohoShowButton}
                buttonColor={zohoTriggerForDebit.buttonColor}
                establishConnection={establishConnection}
                messageForConnection={zohoTriggerForDebit.messageForConnection}
                timerForZohoInSalesCustomer={timers}
                closeZohoDrawer={closeZohoDrawer}
                zohoDateChangeHandler={zohoDateChangeHandler}
                effitracImportFormloader={submitLoaderForDebit}
                fetchingdataForZoho={fetchingdataForZoho}
                zohoDate={zohoDate}
                logApitName="chart_of_accounts"
                nameOfTheModel="Chart of Accounts"
                importToCWS={handleImportToCWS}
                exportToExcel={exportToExcel}
                zohoTableHeader={Header}
                zohoTableColumn={Column}
                drawerKeys={[]}
                autoSync={autoSync} // Pass autoSync prop
                setAutoSync={handleAutoSyncChange} // Pass setAutoSync prop
            />
        </Box>
    );
}